import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import io from 'socket.io-client'
import Hammer from 'react-hammerjs'
import { HTML5Backend } from 'react-dnd-html5-backend-old'
import { DragDropContext } from 'react-dnd-old'
import { FaRegSave } from 'react-icons/fa'
import { AiOutlineAudio } from 'react-icons/ai'
import { confirmVoiceoverGeneration } from '../Admin/voiceoverCredits'
import {
    webSerialConnect,
    initHexState,
    syncHexState,
    updateHexStepMeta,
    clearHexSteps,
    setHexActiveStep,
} from '../../redux/actions/index'
import unicodeToChar from '../../utils/unicodeToChar'
// import DragDropContext from 'react-dnd-old';
// import TouchBackend from 'react-dnd-old-touch-backend';
import getBytes from '../Simulate/BytesGeneration/convertBytes'
import { connect } from 'react-redux'
import HexBoard from './HexBoard'
import BottomPanel from './BottomPanel'
// import RightPanel from './RightPanel'
import SizesHelper from '../../helpers/Sizes'
import Sizes from '../logic/Sizes'
import ProgramToDrawing from './ProgramToDrawing'
import '../../css/logicTwo.css'
import Modal from 'react-modal'
import renderPrgImage from '../../source/programImg'
import LogicPrgm from '../ReusableComponents/PrgmSlider/LogicPrgmTwo/LogicPrgm'
import * as atatus from 'atatus-spa'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { sendBytes } from '../ReusableComponents/ByteTransfer'
import { readBytes } from '../ReusableComponents/ByteTransfer/byteTransfer'
import ProgramHeaderTwo from '../ReusableComponents/Header/ProgramHeaderTwo'
import Footer from '../ReusableComponents/FooterComponent'
import { continousPABytesReadToggle } from '../ReusableComponents/ByteTransfer'
import LogicStepsSlideshow from './LogicStepsSlideshow'
import { fetchHexSteps } from './LogicStepsApi'
import { fetchAssemblySteps } from '../AssemblyTwo/assemblyStepsApi'
import { processAssemblyAccessoriesFromData } from '../AssemblyTwo/assemblyAccessoriesApi'
import defaultPortConnections from '../Assembly/PortConnections'
import {
    flattenToMicroSlides,
    buildStateForMicroSlide,
} from './TutorialReplayEngine'
import {
    computeAllBlockPositions,
    getGridPositionForLastBlock,
    createCodeStep,
    createInsertStep,
    createDeleteStep,
    createSubStep,
    diffPanelState,
    filterMotorCompanionDiffs,
    buildTutorialPayload,
} from './TutorialCaptureEngine'
import {
    generateAidata,
    generateAiresetdata,
} from '../AppMode/AppModeAI/AppModeAiBytesGeneration'
import { getHederTextArr } from '../../utils/langaugeSupport'
import { PORTDATA } from '../Humanoid/defaultData'
import {
    decimalToMSBLSB,
    generateDeviceDataKey,
} from '../ReusableComponents/ByteTransfer/utils'
import {
    getDeviceName,
    isAi1ShowCondition,
    stopByteCondition,
} from '../../utils/utils'
import SavePopUpTwo from '../Code/CreateAction/SavePopUpTwo'

var _ = require('lodash')
var countLogic
var oldDeltaX, oldDeltaY, panning
var idss = []
var IDIS = ''
var clientX, clientY
var drawing,
    drawingNew,
    defaultScale = 1
var panning = false,
    zooming = false,
    dontTriggerClick = false
var finalOffset = { left: 0, top: 0 }
let newArr = []
let num = 0
const history = createBrowserHistory()

const defaultLogic = {
    program: [
        {
            type: 'start',
            state: {
                bic1: false,
                bic2: false,
                bic3: false,
                bid1: false,
                bid2: false,
                bif1: false,
                bif2: false,
                bif3: false,
                bidata1: false,
                bidata2: false,
                asgn1: false,
                asgn2: false,
                asgn3: false,
                asgn4: false,
                asgn5: false,
            },
            bic1: false,
            bic2: false,
            bic3: false,
            bid1: false,
            bid2: false,
            bif1: false,
            bif2: false,
            bif3: false,
            bid3: false,
            bmp3: false,
            bidata1: false,
            bidata2: false,
            asgn1: false,
            asgn2: false,
            asgn3: false,
            asgn4: false,
            asgn5: false,
        },
    ],
    end: { type: 'end', state: 'repeat' },
    insertState: false,

    offset: { left: 0, top: 0 },
    scale: 1,
    currentProgramGuide: 0,
    active: [-1, -1],
    bottomPanel: 'border',
    CUSTOMGROUPACTIONS12: {},
}

// CHNAGE by: SOUMITYA

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     height: "28%",
//     width: " 30%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     backgroundColor: "#9ecee8",
//     border: "2px solid #188dcc",
//     zIndex: 1,
//   },
// };

const saveToLocalStorage = () => {
    let programMode = sessionStorage.programMode
    let connectedDevice = sessionStorage.connectedDevice
    let version = sessionStorage.deviceVersion

    let updatelocalStorage = JSON.parse(localStorage.getItem('recoveryData'))
    if (programMode in updatelocalStorage) {
        if (connectedDevice in updatelocalStorage[programMode]) {
            updatelocalStorage[programMode][connectedDevice][version] =
                sessionStorage
            localStorage.setItem(
                'recoveryData',
                JSON.stringify(updatelocalStorage)
            )
        } else {
            updatelocalStorage[programMode][connectedDevice] = {
                [version]: sessionStorage,
            }
            localStorage.setItem(
                'recoveryData',
                JSON.stringify(updatelocalStorage)
            )
        }
    } else {
        updatelocalStorage[programMode] = {
            [connectedDevice]: {
                [version]: sessionStorage,
            },
        }
        localStorage.setItem('recoveryData', JSON.stringify(updatelocalStorage))
    }
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        height: '23%',
        width: ' 25%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        // backgroundColor: "#9ecee8",
        // border: "2px solid #188dcc",

        border: '5px solid rgb(255,140,25)',
        borderRadius: '20px',

        overflow: 'initial',
        // zIndex: 1,
    },
}

const customStylesUpload = {
    content: {
        top: '50%',
        left: '50%',
        height: ' 30%',
        width: ' 30%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        zIndex: 1000000,
        borderRadius: '15px',
        transform: 'translate(-50%, -50%)',
        border: '5px solid orange',
    },
}

let newId = 0

class LogicTwoContent extends Component {
    constructor(props) {
        super(props)
        this.sendDataRef = React.createRef()
        this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' }
        this.replayFileInputRef = React.createRef()

        this.lastHexStateHash = ''
        this.lastActiveHexRaw = ''
        this.skipHexSyncOnce = false
        this.replayTimerId = null

        this.subprogramTitle = ''

        var { logic } = this.props

        var tutorialLogic = sessionStorage.getItem('tutorialLogic')

        var tutorialDescArray = []
        var selectionType = localStorage.getItem('programMode')

        if (selectionType == 'learn') {
            var tutorialDesc = JSON.parse(
                sessionStorage.getItem('tutorialLogic')
            )
            // tutorialDescArray.push(JSON.parse(tutorialDesc).logic1)
            // tutorialDescArray.push(JSON.parse(tutorialDesc).logic2)
        }

        drawing = ProgramToDrawing(
            undefined,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )
        var curLogicScreen
        curLogicScreen = 'hexa'
        // this.click = this.click.bind(this)
        // this.add = this.add.bind(this)

        this.state = {
            hexType: '',
            uploadOpen: false,
            tutorialDesc: tutorialDesc,
            tutorialLogic: JSON.parse(tutorialLogic),
            modalIsOpen: false,
            clearProgramModal: false,
            usbOpen: false,
            isusb: false,
            isHelp: false,
            currentLogicScreen: curLogicScreen,
            currentNode: {},
            visible: false,
            currentNodeIndex: 0,
            nodeCount: 1,
            detected: false,
            readyForSimulation: '',
            checkEndProgram: false,
            excitDataLimitPopup: false,
            clickedBottom: false,
            isConnected: this.props.isConnected,
            uploadSucessError: { isShow: false, message: '' },
            lowerVersionPcAiToolShow: false,
            slideDirection: sessionStorage.getItem('slideDirection'),
            filePopup: false,
            logicSteps: null,
            stepsSlideIndex: 0,
            hasSubmittedSteps: false,
            hexInteractionLocked: false,
            isReplaying: false,
            replayIndex: 0,
            replayMessage: '',
            // v2.0 Tutorial Capture State
            tutorialCodeSteps: [],
            tutorialStepCounter: 0,
            tutorialMeta: {
                tutorialId: '0',
                title: 'Untitled',
                description: 'No description',
            },
            tutorialRecording: true,
            lastPanelStateSnapshot: null,
            // UI selection for editing tutorial steps/substeps
            selectedTutorialStepIndex: 0,
            selectedTutorialSubStepIndex: 0,
            isGeneratingTTS: false,
            showCaptureMessage: true,
            assemblyScreens: [],
            selectedAssemblyScreen: '',
        }
        this.messageHandler = this.messageHandler.bind(this)

        window.addEventListener('load', async (e) => {
            console.log('HEY_CALIIN', this.props.state)
            navigator.serial.addEventListener('connect', (e) => {
                var user = 1
                sessionStorage.setItem('user', JSON.stringify(user))
                this.handleUsb()
                if (window.location.pathname === '/deviceSelection') {
                    sessionStorage.setItem('autoCunnection', 'true')
                }
                // window.location.reload(false)
            })

            navigator.serial.addEventListener('disconnect', async (e) => {
                var user = 0
                sessionStorage.setItem('user', JSON.stringify(user))
                this.handleUsb()
                const p_Port = this.props.webSerial.port
                try {
                    await p_Port.close()
                } catch (e) {}
            })
            try {
                const portList = await navigator.serial.getPorts()

                if (portList.length === 1) {
                    console.log(portList, 'Hardware connected')
                    let port1 = portList[0]
                    await props.webSerialConnect({ port: port1 }) // dispatching function of redux
                    //debugger;
                    this.setState.p1({
                        selected: true,
                        port: portList[0],
                    })
                } else {
                    console.log('No hardware')

                    this.setState.p1(this.state.p1)
                }
            } catch (err) {
                console.log(err.message)
            }
        })
    }

    safeStringify = (value) => {
        try {
            return JSON.stringify(value)
        } catch (e) {
            return ''
        }
    }

    normalizeHexStateForCompare = (hexState) => {
        let cloned = null
        try {
            cloned = JSON.parse(JSON.stringify(hexState))
        } catch (e) {
            cloned = hexState
        }

        if (cloned && cloned.logicTwoContent) {
            delete cloned.logicTwoContent.offset
            delete cloned.logicTwoContent.scale
        }
        return cloned
    }

    getHexStateHash = (hexState) => {
        return this.safeStringify(this.normalizeHexStateForCompare(hexState))
    }

    getHexStateSnapshot = () => {
        let logicTwoContent = null
        let currentActiveHexBlock = null

        const logicTwoContentRaw = sessionStorage.getItem('logicTwoContent')
        if (logicTwoContentRaw) {
            try {
                logicTwoContent = JSON.parse(logicTwoContentRaw)
            } catch (e) {}
        }

        if (!logicTwoContent) {
            logicTwoContent = this.props.logic
        }

        const activeHexRaw = sessionStorage.getItem('currentActiveHexBlock')
        if (activeHexRaw) {
            try {
                currentActiveHexBlock = JSON.parse(activeHexRaw)
            } catch (e) {}
        }

        return {
            logicTwoContent,
            currentActiveHexBlock,
        }
    }

    syncHexStateFromSession = (isInit) => {
        const hexState = this.getHexStateSnapshot()
        const nextHash = this.getHexStateHash(hexState)

        if (nextHash && nextHash === this.lastHexStateHash) {
            return
        }

        this.lastHexStateHash = nextHash
        this.lastActiveHexRaw =
            sessionStorage.getItem('currentActiveHexBlock') || ''

        if (isInit) {
            this.props.initHexState(hexState)
            return
        }

        this.props.syncHexState(hexState)
    }

    componentWillMount = () => {
        // Ensure connectedDevice is set (admin flow may not set it).
        // Derive it from the admin-selected board (allowedDevice) so the editor
        // behaves correctly for Toki, Poki, etc. — falling back to Toki only when
        // nothing is selected.
        if (!sessionStorage.getItem('connectedDevice')) {
            sessionStorage.setItem(
                'connectedDevice',
                sessionStorage.getItem('allowedDevice') || 'Toki'
            )
            sessionStorage.setItem('deviceVersion', '1')
        }

        // Extract subId from route and persist as apiProjectId
        if (this.props.match?.params?.subId) {
            sessionStorage.setItem(
                'apiProjectId',
                this.props.match.params.subId
            )
        }

        // Extract screenId from route and persist
        if (this.props.match?.params?.screenId) {
            sessionStorage.setItem(
                'apiScreenId',
                this.props.match.params.screenId
            )
        }

        // Ensure concept is in sessionStorage (admin may navigate directly
        // without visiting AssemblyTwo; sub-panels read concept from sessionStorage)
        if (!sessionStorage.getItem('concept')) {
            const defaultConcept = {
                counter: [],
                componentProps: {},
                Index: [],
                internalaccessories: this.props.concept
                    ?.internalaccessories || {
                    Four_in_one_sensor: {
                        isDistanceSensors: false,
                        isGestureSensor: false,
                        isLightSensor: false,
                        isColorSensor: false,
                    },
                    isFour_in_one_sensor: false,
                    isTouchZero: false,
                    isTouchOne: false,
                    isTouchTwo: false,
                    isTouchThree: false,
                    isTouchZeroOutput: false,
                    isTouchOneOutput: false,
                    isTouchTwoOutput: false,
                    isTouchThreeOutput: false,
                    isMic: false,
                    isTemperature: false,
                    isBattery: false,
                    isAccelerometer: false,
                    isLeftEye: false,
                    isRightEye: false,
                    isEYES: false,
                    isbuzzer: false,
                    isSmileOne: false,
                    isSmileTwo: false,
                    isSmileThree: false,
                    isSmileFour: false,
                    isUltrasonic: false,
                    isGyroX: false,
                    isGyroY: false,
                    isGyroZ: false,
                    isAccelerometerX: false,
                    isAccelerometerY: false,
                    isAccelerometerZ: false,
                    isLeftRGB: false,
                    isRightRGB: false,
                    isMp3: false,
                    isHeadServo: false,
                    isIndivdualServo: false,
                    isActionGroup: false,
                    isM1: false,
                    isM2: false,
                    isSimpleServo: false,
                    isAtrMotor1: false,
                    isAtrMotor2: false,
                    isAtrMotor3: false,
                    isIr: false,
                },
                disableAfterSettingByt: false,
                zingMp3List: [],
            }
            sessionStorage.setItem('concept', JSON.stringify(defaultConcept))
        }

        // Ensure assemblyTwo is in sessionStorage
        if (!sessionStorage.getItem('assemblyTwo')) {
            const defaultAssemblyTwo = {
                PortConnections: { ...defaultPortConnections },
                workspace: {
                    bibox: { top: 208, left: 328 },
                    components: {},
                    offset: { top: 0, left: 0 },
                    scale: 1,
                },
                height: document.body.clientHeight,
                width: document.body.clientWidth,
            }
            sessionStorage.setItem(
                'assemblyTwo',
                JSON.stringify(defaultAssemblyTwo)
            )
        }

        sessionStorage.setItem('isReadingZingPA', false)
        atatus.beginTransaction('Logic Screen')
        const { program, end, insertState, currentProgramGuide, active } =
            this.props.logic

        // Sync 'logic' sessionStorage with logicTwoContent so sub-panels can read it
        sessionStorage.setItem('logic', JSON.stringify(this.props.logic))

        drawing = ProgramToDrawing(
            undefined,
            program,
            end,
            currentProgramGuide,
            active,
            this.add,
            insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )
    }
    componentWillUnmount() {
        this.props.worker.removeEventListener('message', this.messageHandler)
        atatus.endTransaction('Logic Screen')
        if (this.replayTimerId) {
            clearTimeout(this.replayTimerId)
        }
        if (this._captureMessageTimer) clearTimeout(this._captureMessageTimer)
    }
    componentWillUpdate(nextProps, nextState) {
        const { program, end, insertState, currentProgramGuide, active } =
            this.props.logic

        drawing = ProgramToDrawing(
            undefined,
            program,
            end,
            currentProgramGuide,
            active,
            this.add,
            insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )
    }

    componentDidUpdate(prevProps) {
        // v2.0: Capture is done explicitly in add/insertNode/toggleBottomPanel/bottomPanelChange
        // Skip sync when replaying to prevent feedback loops
        if (this.skipHexSyncOnce) {
            this.skipHexSyncOnce = false
        }

        // Keep 'logic' sessionStorage in sync so sub-panels (OutputPanel etc.) read current data
        if (prevProps.logic !== this.props.logic) {
            sessionStorage.setItem('logic', JSON.stringify(this.props.logic))
        }
    }
    OpenReadComPort = async () => {
        const port = this.props.webSerial.port
        console.log('PORTLIST', port)
        // console.log(port, "pPort");
        try {
            // await port.close();
            await port.open({ baudRate: 120000 })
        } catch (e) {
            console.log(e)
        }
        // this.writePort("notWrite");
        // let valresponceTp0 = "",
        //   valdis = "";
        // // setTimeout(async () => {
        // if (this.state.readbytes) {
        // this.readdata();
        // }

        // }, 1000);
    }

    stopPaOnBack = () => {
        if (this.state.isPcActive) {
            this.setState({ readbytes: false })
            this.setState({ isPcActive: false })
        }
        if (this.state.isReading) {
            this.setState({ isReading: false })
            sessionStorage.setItem('isReadingZingPA', false)
            // this.continuesPAstop()
        }
    }

    handleHeaderTabClick = (index) => {
        if (index > 2) {
            return
        }

        this.stopPaOnBack()

        if (index === 0) {
            this.props.history.push('/playdynamexNew')
        }
        if (index === 1) {
            this.props.history.push('/assemblyTwo')
        }
        if (index === 2) {
            this.props.history.push('/logicTwo')
        }
    }

    handleUsb = (e) => {
        this.setState({ isusb: !this.state.isusb })
    }
    helpBtn = (e) => {
        this.setState({ isHelp: !this.state.isHelp })
    }
    clearProgramTrue = () => {
        this.setState({ clearProgramModal: true })
    }
    clearProgramfalse = () => {
        this.setState({ clearProgramModal: false })
    }
    clearProgram = async () => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        sessionStorage.removeItem('logicTwoContent')
        sessionStorage.removeItem('programEnd')
        // window.location.reload(false)

        this.props.update(JSON.parse(JSON.stringify(defaultLogic)))
        await new Promise((reslove) => setTimeout(reslove, 0))

        sessionStorage.removeItem('EndSwitch')
        ///////// Humanoid Program Data ///////////
        sessionStorage.removeItem('humanoidProgramData')
        sessionStorage.removeItem('PET')

        this.setState({ clearProgramModal: false })
    }

    /**
     * Ensure concept.componentProps is populated so the OutputPanel
     * can render hardware controls for connected components.
     * Uses existing sessionStorage assemblyTwo data to derive steps,
     * then calls processAssemblyAccessoriesFromData which builds
     * componentProps with ALL device types.
     */
    _ensureComponentProps = () => {
        try {
            const concept = JSON.parse(
                sessionStorage.getItem('concept') || '{}'
            )
            // Skip if componentProps already has entries
            if (
                concept.componentProps &&
                Object.keys(concept.componentProps).length > 0
            ) {
                return
            }

            // Build steps array from existing assemblyTwo workspace
            const assemblyTwo = JSON.parse(
                sessionStorage.getItem('assemblyTwo') || 'null'
            )
            const steps = []
            if (assemblyTwo?.workspace?.components) {
                Object.entries(assemblyTwo.workspace.components).forEach(
                    ([componentType, arr]) => {
                        if (Array.isArray(arr)) {
                            arr.forEach((comp) => {
                                if (comp.connectedTo) {
                                    steps.push({
                                        component: componentType,
                                        port: comp.connectedTo,
                                    })
                                }
                            })
                        }
                    }
                )
            }

            // processAssemblyAccessoriesFromData builds componentProps
            // with ALL device types (even with empty steps/accessories)
            processAssemblyAccessoriesFromData({
                steps,
                internalAccessories: [],
                externalAccessories: steps.map((s) => s.component),
            })

            // Sync to Redux
            const updatedConcept = JSON.parse(
                sessionStorage.getItem('concept') || '{}'
            )
            if (
                updatedConcept.componentProps &&
                this.props.updateConceptComponentProps
            ) {
                this.props.updateConceptComponentProps(
                    updatedConcept.componentProps
                )
            }
        } catch (e) {
            console.error('LogicTwoContent: Failed to ensure componentProps', e)
        }
    }

    fetchAssemblyScreenList = async () => {
        try {
            const apiProjectId =
                this.props.match?.params?.subId ||
                sessionStorage.getItem('apiProjectId') ||
                'talking-dragon'
            const BACKEND_URL = process.env.REACT_APP_API_BASE || ''
            const res = await fetch(
                `${BACKEND_URL}/api/staging/screens/assembly/${encodeURIComponent(apiProjectId)}`,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                }
            )
            if (!res.ok) return
            const data = await res.json()
            console.log('LogicTwoContent: Fetched assembly screens', data)
            const screens = data.screens || []
            this.setState({
                assemblyScreens: screens,
            })
        } catch (e) {
            console.error(
                'LogicTwoContent: Failed to fetch assembly screens',
                e
            )
        }
    }

    handleAssemblyScreenChange = async (screenId) => {
        this.setState({ selectedAssemblyScreen: screenId }, async () => {
            await this.ensureAssemblyConnections()
        })
    }

    ensureAssemblyConnections = async (overrideScreenId) => {
        try {
            // Always fetch from staging API for logicTwoContent (admin preview)
            const apiProjectId =
                this.props.match?.params?.subId ||
                sessionStorage.getItem('apiProjectId') ||
                'talking-dragon'
            const isPreviewMode = true

            // USE THE OVERRIDE ID IF PROVIDED, OTHERWISE FALLBACK TO STATE
            const assemblyScreenId =
                overrideScreenId !== undefined
                    ? overrideScreenId
                    : this.state.selectedAssemblyScreen || ''

            const stepsData = await fetchAssemblySteps(
                apiProjectId,
                isPreviewMode,
                assemblyScreenId
            )
            if (!stepsData?.steps?.length) {
                console.warn(
                    'LogicTwoContent: No assembly steps returned from backend'
                )
                // Even with no backend steps, ensure componentProps is populated
                // from existing sessionStorage assemblyTwo data (user may have
                // set up connections on AssemblyAdmin page)
                this._ensureComponentProps()
                return
            }

            console.log(
                'LogicTwoContent: Auto-building assemblyTwo connections from',
                stepsData.steps.length,
                'assembly steps'
            )

            // ================================================================
            // NEW ADDITION: Map and Update Internal Accessories
            // ================================================================
            const defaultInternalAccessories = {
                Four_in_one_sensor: {
                    isDistanceSensors: false,
                    isGestureSensor: false,
                    isLightSensor: false,
                    isColorSensor: false,
                },
                isFour_in_one_sensor: false,
                isTouchZero: false,
                isTouchOne: false,
                isTouchTwo: false,
                isTouchThree: false,
                isTouchZeroOutput: false,
                isTouchOneOutput: false,
                isTouchTwoOutput: false,
                isTouchThreeOutput: false,
                isMic: false,
                isTemperature: false,
                isBattery: false,
                isAccelerometer: false,
                isLeftEye: false,
                isRightEye: false,
                isEYES: false,
                isbuzzer: false,
                isSmileOne: false,
                isSmileTwo: false,
                isSmileThree: false,
                isSmileFour: false,
                isUltrasonic: false,
                isGyroX: false,
                isGyroY: false,
                isGyroZ: false,
                isAccelerometerX: false,
                isAccelerometerY: false,
                isAccelerometerZ: false,
                isLeftRGB: false,
                isRightRGB: false,
                isMp3: false,
                isHeadServo: false,
                isIndivdualServo: false,
                isActionGroup: false,
                isM1: false,
                isM2: false,
                isSimpleServo: false,
                isAtrMotor1: false,
                isAtrMotor2: false,
                isAtrMotor3: false,
                isIr: false,
            }

            // Hardcoded mapping dictionary
            const accessoryNameMap = {
                'ir sensor': 'isIr',
            }

            // Check if backend returned internalAccessories array and process it
            if (
                stepsData.internalAccessories &&
                Array.isArray(stepsData.internalAccessories)
            ) {
                stepsData.internalAccessories.forEach((acc) => {
                    // Standardize string to lowercase to match our dictionary keys
                    const mappedKey = accessoryNameMap[acc.toLowerCase()]
                    if (
                        mappedKey &&
                        defaultInternalAccessories.hasOwnProperty(mappedKey)
                    ) {
                        defaultInternalAccessories[mappedKey] = true
                    }
                })
            }

            // 1. Update sessionStorage so it persists globally
            try {
                let conceptData = JSON.parse(
                    sessionStorage.getItem('concept') || '{}'
                )
                conceptData.internalaccessories = defaultInternalAccessories
                sessionStorage.setItem('concept', JSON.stringify(conceptData))
            } catch (e) {
                console.error('Failed to update concept in sessionStorage', e)
            }

            // 2. Dispatch to Redux so UI components immediately reflect the true/false states
            if (this.props.updateConceptInternalAccessories) {
                this.props.updateConceptInternalAccessories(
                    defaultInternalAccessories
                )
            }
            // ================================================================
            // END OF NEW ADDITION
            // ================================================================

            const connectedDevice = sessionStorage.getItem('connectedDevice')
            const isTokiFamily = ['Toki', 'Poki'].includes(connectedDevice)
            const portConnections = { ...defaultPortConnections }
            const workspaceComponents = {}

            stepsData.steps.forEach((step) => {
                const componentType = step.component
                const port = step.port
                if (!componentType || !port) return

                if (!workspaceComponents[componentType]) {
                    workspaceComponents[componentType] = []
                }
                const componentIndex = workspaceComponents[componentType].length
                workspaceComponents[componentType].push({
                    left: 0,
                    top: 0,
                    connectedTo: port,
                })

                portConnections[port] = {
                    type: componentType,
                    index: componentIndex,
                }

                if (!isTokiFamily && port === 'M1') {
                    portConnections['M2'] = {
                        type: componentType,
                        index: componentIndex,
                    }
                }
                if (!isTokiFamily && port === 'M3') {
                    portConnections['M4'] = {
                        type: componentType,
                        index: componentIndex,
                    }
                }
            }) // Dispatch to Redux so child components re-render with updated data

            this.props.updateAssemblyTwoWorkspace({
                bibox: { top: 208, left: 328 },
                components: workspaceComponents,
                offset: { top: 0, left: 0 },
                scale: 1,
            })
            this.props.updateAssemblyTwoPortConnections(portConnections)

            // Build componentProps so the OutputPanel can render hardware controls.
            // processAssemblyAccessoriesFromData populates concept.componentProps
            // in sessionStorage with entries for ALL device component types.
            processAssemblyAccessoriesFromData(stepsData)

            // Sync the updated componentProps into Redux
            try {
                const updatedConcept = JSON.parse(
                    sessionStorage.getItem('concept') || '{}'
                )
                if (
                    updatedConcept.componentProps &&
                    this.props.updateConceptComponentProps
                ) {
                    this.props.updateConceptComponentProps(
                        updatedConcept.componentProps
                    )
                }
            } catch (e) {
                console.error(
                    'LogicTwoContent: Failed to sync componentProps to Redux',
                    e
                )
            }

            console.log(
                'LogicTwoContent: assemblyTwo connections auto-built successfully',
                portConnections
            )
        } catch (err) {
            console.error(
                'LogicTwoContent: Failed to auto-build assembly connections:',
                err
            )
        }
    }

    fetchSubprogramTitle = async () => {
        const BACKEND_URL = process.env.REACT_APP_API_BASE || ''
        let subId = this.props.match?.params?.subId || ''

        // Fallback path parse for routes that don't expose params cleanly.
        if (!subId) {
            const currentPath = window.location.hash || window.location.pathname
            const pathSegments = currentPath.split('/').filter(Boolean)
            const adminIndex = pathSegments.indexOf('makeAdmin')
            if (adminIndex !== -1 && pathSegments.length > adminIndex + 1) {
                subId = pathSegments[adminIndex + 1]
            }
        }

        if (!subId) return ''

        const res = await fetch(`${BACKEND_URL}/api/program/staging/${(sessionStorage.getItem('allowedDevice') || 'Toki').toLowerCase()}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
        })

        const data = await res.json()
        if (!res.ok) {
            throw new Error(data.error || 'Failed to get program data')
        }

        const matchedSubprogram = (data.subprograms || []).find(
            (s) => s.id === subId
        )

        return matchedSubprogram?.title || ''
    }

    componentDidMount = async () => {
        this._isMounted = true

        await this.fetchAssemblyScreenList()
        // await this.ensureAssemblyConnections()
        await this.loadLogicSteps()

        try {
            this.subprogramTitle = await this.fetchSubprogramTitle()
        } catch (err) {
            console.error('Failed to fetch subprogram title:', err)
            this.subprogramTitle = ''
        }

        // Hide capture banner after 3 seconds
        this._captureMessageTimer = setTimeout(() => {
            this.setState({ showCaptureMessage: false })
        }, 10000)

        // var socket = io.connect("http://localhost:3008");
        // socket.emit("_usbDetection", "Hi");
        // socket.on("/usbDetection1", (data) => {
        //   // console.log("...............1", data);
        //   // // let kill = Array.from(data);
        //   // // console.log("...............5", kill);
        //   // if (data == 1) {
        //   //   this.handleUsb(true);
        //   //   console.log("LLLLLLLLLLLLLLL", data);
        //   // } else {
        //   //   this.handleUsb(false);
        //   // }
        // });
        // await new Promise((resolve) =>
        //     setTimeout(() => {
        //         this.setState({
        //             showUpload: true,
        //         })
        //         resolve()
        //     }, 2000)
        // )
        let data = JSON.parse(sessionStorage.getItem('user'))

        if (data === 1) {
            this.setState({
                isusb: true,
            })
            console.log('Logic AD !!')
            // this.setState({ isusb: true });
        }
        if (data === 0) {
            this.setState({
                isusb: false,
            })
            console.log('Logic AD')
            // this.setState({ isusb: false });
        }
        // socket.on("/usbDetection", (data) => {
        //   console.log("DATAE:----", data);
        //   this.setState({ detected: data.detected, usbOpen: !data.detected });
        // });
        // this.setState({ hexType: "wait" })
        if (sessionStorage.getItem('programEnd') != null) {
            this.setState({ readyForSimulation: 'repeat' })
        }

        this.props.worker.addEventListener('message', this.messageHandler)
    }

    handleGenerateVoiceover = async () => {
        // Single confirmation gate: save reminder + estimated credit cost.
        // Reconstruct the saved hex payload (codeSteps + final slides, expanded
        // with subSteps) so the estimate mirrors what the TTS pipeline narrates.
        const estimatePayload = buildTutorialPayload(
            this.state.tutorialCodeSteps || [],
            this.state.tutorialMeta
        )
        estimatePayload.finalStepInstruction1 =
            'Excellent! You have successfully built the logic.'
        estimatePayload.finalStepInstruction2 =
            'Please upload the code to see it in action!'
        if (!confirmVoiceoverGeneration(estimatePayload)) return

        const BACKEND_URL = process.env.REACT_APP_API_BASE || ''

        // Extract projectId from URL
        let projectId = 'talking-dragon'
        const currentPath = window.location.hash || window.location.pathname
        const pathSegments = currentPath.split('/')
        const adminIndex = pathSegments.indexOf('makeAdmin')
        if (adminIndex !== -1 && pathSegments.length > adminIndex + 1) {
            projectId = pathSegments[adminIndex + 1]
        }

        // Extract screenId from URL params or path
        let screenId = this.props.match?.params?.screenId || ''
        if (!screenId) {
            const hexAdminIndex = pathSegments.indexOf('hexAdmin')
            if (
                hexAdminIndex !== -1 &&
                pathSegments.length > hexAdminIndex + 1
            ) {
                screenId = pathSegments[hexAdminIndex + 1]
            }
        }

        const currentScreenId = screenId || 'hex1'

        this.setState({ isGeneratingTTS: true })
        try {
            // --- READ FROM LOCAL STORAGE ---
            const apiKey = localStorage.getItem('freepikApiKey')
            const voiceId = localStorage.getItem('elevenVoiceId')
            if (!apiKey || !voiceId) {
                window.alert(
                    'Missing TTS Configuration!\n\nPlease go back to the main Toki Engine Admin page and set the ElevenLabs API Key and Voice ID before generating voiceovers.'
                )
                this.setState({ isGeneratingTTS: false })
                return
            }

            const res = await fetch(
                `${BACKEND_URL}/api/project/${projectId}/generate-tts/hex/${currentScreenId}`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ apiKey, voiceId }),
                }
            )
            const data = await res.json()
            if (!res.ok) {
                throw new Error(data.error || 'Failed to generate voiceover')
            }
            alert(`\u2705 ${data.message}`)
        } catch (error) {
            console.error('TTS Generation error:', error)
            alert(`\u274C Error generating voiceover: ${error.message}`)
        } finally {
            this.setState({ isGeneratingTTS: false })
        }
    }

    handleHexStepMetaChange = (field, value) => {
        this.setState((prev) => ({
            tutorialMeta: { ...prev.tutorialMeta, [field]: value },
        }))
        // Do nothing for now. Later we will update the tutorial title using this.
    }

    // ───────── v2.0 Tutorial Capture Methods ─────────

    captureBlockPlaced = (internalType, guideLevel, exactRow, exactCol) => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return
        // Skip end_* closing types — they are structural, not user actions
        // if (typeof internalType === 'string' && internalType.startsWith('end_'))
        //     return

        const { logic } = this.props
        const guide =
            guideLevel !== undefined ? guideLevel : logic.currentProgramGuide

        // Get the base grid position
        // const gridPos = getGridPositionForLastBlock(logic.program, guide)

        // 🚨 NEW: Prioritize the exact clicked UI coordinates!
        let gridPos
        if (exactRow != null && exactCol != null) {
            gridPos = { row: exactRow, col: exactCol }
        } else {
            // Fallback for any automated placement
            gridPos = getGridPositionForLastBlock(logic.program, guide)
        }

        this.setState((prev) => {
            const stepId = prev.tutorialStepCounter + 1
            const codeStep = createCodeStep(stepId, internalType, gridPos)
            return {
                tutorialCodeSteps: [...prev.tutorialCodeSteps, codeStep],
                tutorialStepCounter: stepId,
                currentCapturingStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialSubStepIndex: 0,
            }
        })
    }

    captureBlockInserted = (internalType, blockRef) => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return
        // if (typeof internalType === 'string' && internalType.startsWith('end_'))
        //     return

        const { logic } = this.props
        const positions = computeAllBlockPositions(logic.program)
        const match = positions.find((p) => p.ref === blockRef)
        const gridPos = match
            ? { row: match.row, col: match.col }
            : { row: 1, col: 1 }

        this.setState((prev) => {
            const stepId = prev.tutorialStepCounter + 1
            const codeStep = createCodeStep(stepId, internalType, gridPos)
            return {
                tutorialCodeSteps: [...prev.tutorialCodeSteps, codeStep],
                tutorialStepCounter: stepId,
                currentCapturingStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialSubStepIndex: 0,
            }
        })
    }

    /**
     * Compute the nesting path from logic.program to the given parentRef array.
     * Returns an array of indices, e.g. [2] means program[2].subprogram,
     * [2, 1] means program[2].subprogram[1].subprogram, etc.
     * Returns [] for top-level (parentRef === program).
     */
    computeNestingPath = (program, parentRef) => {
        if (program === parentRef) return []

        const path = []
        const search = (instructions) => {
            for (let i = 0; i < instructions.length; i++) {
                if (instructions[i].subprogram === parentRef) {
                    path.push(i)
                    return true
                }
                if (instructions[i].subprogram) {
                    path.push(i)
                    if (search(instructions[i].subprogram)) return true
                    path.pop()
                }
            }
            return false
        }
        search(program)
        return path
    }

    captureBlockInsertedBetween = (internalType, insertIndex, parentRef) => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return
        // if (typeof internalType === 'string' && internalType.startsWith('end_'))
        //     return

        const { logic } = this.props
        const positions = computeAllBlockPositions(logic.program)
        // The inserted block is now at parentRef[insertIndex]
        const blockRef = parentRef[insertIndex]
        const match = blockRef
            ? positions.find((p) => p.ref === blockRef)
            : null
        const gridPos = match
            ? { row: match.row, col: match.col }
            : { row: 1, col: insertIndex + 1 }
        const nestingPath = this.computeNestingPath(logic.program, parentRef)

        this.setState((prev) => {
            const stepId = prev.tutorialStepCounter + 1
            const codeStep = createInsertStep(
                stepId,
                internalType,
                gridPos,
                insertIndex,
                nestingPath
            )
            return {
                tutorialCodeSteps: [...prev.tutorialCodeSteps, codeStep],
                tutorialStepCounter: stepId,
                currentCapturingStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialSubStepIndex: 0,
            }
        })
    }

    captureBlockDeleted = (internalType, deleteIndex, parentRef, gridPos) => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return

        const { logic } = this.props
        const nestingPath = this.computeNestingPath(logic.program, parentRef)

        this.setState((prev) => {
            const stepId = prev.tutorialStepCounter + 1
            const codeStep = createDeleteStep(
                stepId,
                internalType,
                gridPos,
                deleteIndex,
                nestingPath
            )
            return {
                tutorialCodeSteps: [...prev.tutorialCodeSteps, codeStep],
                tutorialStepCounter: stepId,
                currentCapturingStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialStepIndex: prev.tutorialCodeSteps.length,
                selectedTutorialSubStepIndex: 0,
            }
        })
    }

    capturePanelOpened = () => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return

        let stateSnapshot = null
        if (drawing.activeRef && drawing.activeRef.state != null) {
            stateSnapshot =
                typeof drawing.activeRef.state === 'object'
                    ? JSON.parse(JSON.stringify(drawing.activeRef.state))
                    : drawing.activeRef.state
        }

        this.setState((prev) => {
            const steps = prev.tutorialCodeSteps
            if (steps.length === 0) return null

            const currentStep = steps[steps.length - 1]
            const subIndex = currentStep.subSteps.length + 1

            const subStep = createSubStep(
                currentStep.stepId,
                subIndex,
                'OPEN_MENU',
                {
                    uiTarget: currentStep.boardTarget,
                    message: `Double-click the ${
                        currentStep.blockType
                    } block to open its configuration.`,
                }
            )

            const updatedStep = {
                ...currentStep,
                subSteps: [...currentStep.subSteps, subStep],
            }
            const updatedSteps = [...steps.slice(0, -1), updatedStep]

            return {
                tutorialCodeSteps: updatedSteps,
                lastPanelStateSnapshot: stateSnapshot,
            }
        })
    }

    captureValueChanged = (newState) => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return

        // Debounce: DC motor sliders fire onChange for both port1 and port2
        // in rapid succession. Buffer the latest state and diff after a short
        // delay so paired port changes are captured as a single batch.
        clearTimeout(this._captureValueTimer)
        this._pendingCaptureState =
            typeof newState === 'object'
                ? JSON.parse(JSON.stringify(newState))
                : newState

        this._captureValueTimer = setTimeout(() => {
            const bufferedState = this._pendingCaptureState
            this._pendingCaptureState = null

            this.setState((prev) => {
                const steps = prev.tutorialCodeSteps
                if (steps.length === 0) return null

                const currentStep = steps[steps.length - 1]
                const oldState = prev.lastPanelStateSnapshot
                const blockType = currentStep.blockType

                const diffs = filterMotorCompanionDiffs(
                    diffPanelState(oldState, bufferedState, blockType)
                )
                if (diffs.length === 0) return null

                let updatedSubSteps = [...currentStep.subSteps]

                for (const diff of diffs) {
                    // Debounce: if last subStep has same action + hardwareKey, update value
                    const lastSub = updatedSubSteps[updatedSubSteps.length - 1]
                    if (
                        lastSub &&
                        lastSub.action === diff.action &&
                        lastSub.hardwareKey === diff.hardwareKey
                    ) {
                        updatedSubSteps[updatedSubSteps.length - 1] = {
                            ...lastSub,
                            expectedValue: diff.expectedValue,
                            message: diff.message,
                        }
                    } else {
                        const subIndex = updatedSubSteps.length + 1
                        const subStep = createSubStep(
                            currentStep.stepId,
                            subIndex,
                            diff.action,
                            {
                                hardwareKey: diff.hardwareKey,
                                expectedValue: diff.expectedValue,
                                uiTarget: diff.uiTarget,
                                message: diff.message,
                            }
                        )
                        updatedSubSteps.push(subStep)
                    }
                }

                const updatedStep = {
                    ...currentStep,
                    subSteps: updatedSubSteps,
                }
                const updatedSteps = [...steps.slice(0, -1), updatedStep]

                return {
                    tutorialCodeSteps: updatedSteps,
                    lastPanelStateSnapshot: bufferedState,
                }
            })
        }, 200)
    }

    // Flush any pending debounced capture before processing a new event
    _flushPendingCapture = () => {
        if (this._captureValueTimer) {
            clearTimeout(this._captureValueTimer)
            this._captureValueTimer = null
            if (this._pendingCaptureState != null) {
                const bufferedState = this._pendingCaptureState
                this._pendingCaptureState = null
                this.setState((prev) => {
                    const steps = prev.tutorialCodeSteps
                    if (steps.length === 0) return null
                    const currentStep = steps[steps.length - 1]
                    const oldState = prev.lastPanelStateSnapshot
                    const blockType = currentStep.blockType
                    const diffs = filterMotorCompanionDiffs(
                        diffPanelState(oldState, bufferedState, blockType)
                    )
                    if (diffs.length === 0) return null
                    let updatedSubSteps = [...currentStep.subSteps]
                    for (const diff of diffs) {
                        const lastSub =
                            updatedSubSteps[updatedSubSteps.length - 1]
                        if (
                            lastSub &&
                            lastSub.action === diff.action &&
                            lastSub.hardwareKey === diff.hardwareKey
                        ) {
                            updatedSubSteps[updatedSubSteps.length - 1] = {
                                ...lastSub,
                                expectedValue: diff.expectedValue,
                                message: diff.message,
                            }
                        } else {
                            updatedSubSteps.push(
                                createSubStep(
                                    currentStep.stepId,
                                    updatedSubSteps.length + 1,
                                    diff.action,
                                    {
                                        hardwareKey: diff.hardwareKey,
                                        expectedValue: diff.expectedValue,
                                        uiTarget: diff.uiTarget,
                                        message: diff.message,
                                    }
                                )
                            )
                        }
                    }
                    return {
                        tutorialCodeSteps: [
                            ...steps.slice(0, -1),
                            { ...currentStep, subSteps: updatedSubSteps },
                        ],
                        lastPanelStateSnapshot: bufferedState,
                    }
                })
            }
        }
    }

    capturePanelClosed = () => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return

        this._flushPendingCapture()

        this.setState((prev) => {
            const steps = prev.tutorialCodeSteps
            if (steps.length === 0) return null

            const currentStep = steps[steps.length - 1]
            const subIndex = currentStep.subSteps.length + 1

            const subStep = createSubStep(
                currentStep.stepId,
                subIndex,
                'CLOSE_MENU',
                {
                    uiTarget: 'btn_modal_close',
                    message: 'Close the configuration panel.',
                }
            )

            const updatedStep = {
                ...currentStep,
                subSteps: [...currentStep.subSteps, subStep],
            }
            const updatedSteps = [...steps.slice(0, -1), updatedStep]

            return {
                tutorialCodeSteps: updatedSteps,
                lastPanelStateSnapshot: null,
            }
        })
    }

    /**
     * Capture Read-related actions from the decision panel.
     * @param {'SELECT_READ_SOURCE'|'READ_SENSOR'} action
     * @param {string} readSource - the sensor selected in the Read dropdown (e.g. 'IR', 'A1')
     */
    captureReadAction = (action, readSource) => {
        if (!this.state.tutorialRecording || this.state.isReplaying) return

        this.setState((prev) => {
            const steps = prev.tutorialCodeSteps
            if (steps.length === 0) return null

            const currentStep = steps[steps.length - 1]
            let updatedSubSteps = [...currentStep.subSteps]

            if (action === 'SELECT_READ_SOURCE') {
                // Debounce: if last subStep is also SELECT_READ_SOURCE, update it
                const lastSub = updatedSubSteps[updatedSubSteps.length - 1]
                if (lastSub && lastSub.action === 'SELECT_READ_SOURCE') {
                    updatedSubSteps[updatedSubSteps.length - 1] = {
                        ...lastSub,
                        expectedValue: readSource,
                        message: `Select "${readSource}" from the Read dropdown.`,
                    }
                } else {
                    const subIndex = updatedSubSteps.length + 1
                    updatedSubSteps.push(
                        createSubStep(
                            currentStep.stepId,
                            subIndex,
                            'SELECT_READ_SOURCE',
                            {
                                hardwareKey: 'readSource',
                                expectedValue: readSource,
                                uiTarget: 'input_readSource',
                                message: `Select "${readSource}" from the Read dropdown.`,
                            }
                        )
                    )
                }
            } else if (action === 'READ_SENSOR') {
                const subIndex = updatedSubSteps.length + 1
                updatedSubSteps.push(
                    createSubStep(currentStep.stepId, subIndex, 'READ_SENSOR', {
                        hardwareKey: 'readAction',
                        expectedValue: readSource,
                        uiTarget: 'btn_read_sensor',
                        message: `Click "Read" to read the ${readSource} sensor value.`,
                    })
                )
            }

            const updatedStep = {
                ...currentStep,
                subSteps: updatedSubSteps,
            }
            const updatedSteps = [...steps.slice(0, -1), updatedStep]

            return { tutorialCodeSteps: updatedSteps }
        })
    }

    setSelectedTutorialStepIndex = (index) => {
        const maxIndex = Math.max(this.state.tutorialCodeSteps.length - 1, 0)
        const nextIndex = Math.min(Math.max(0, index), maxIndex)
        this.setState({
            selectedTutorialStepIndex: nextIndex,
            selectedTutorialSubStepIndex: 0,
        })
    }

    setSelectedTutorialSubStepIndex = (index) => {
        const steps = this.state.tutorialCodeSteps
        const step = steps[this.state.selectedTutorialStepIndex]
        if (!step || !Array.isArray(step.subSteps)) {
            this.setState({ selectedTutorialSubStepIndex: 0 })
            return
        }
        const maxIndex = Math.max(step.subSteps.length - 1, 0)
        const nextIndex = Math.min(Math.max(0, index), maxIndex)
        this.setState({ selectedTutorialSubStepIndex: nextIndex })
    }

    updateSelectedStepMessage = (message) => {
        this.setState((prev) => {
            const steps = [...prev.tutorialCodeSteps]
            const idx = prev.selectedTutorialStepIndex
            if (idx < 0 || idx >= steps.length) return null
            steps[idx] = { ...steps[idx], message }
            return { tutorialCodeSteps: steps }
        })
    }

    updateSelectedStepField = (field, value) => {
        this.setState((prev) => {
            const steps = [...prev.tutorialCodeSteps]
            const idx = prev.selectedTutorialStepIndex
            if (idx < 0 || idx >= steps.length) return null
            steps[idx] = { ...steps[idx], [field]: value }
            return { tutorialCodeSteps: steps }
        })
    }

    updateSelectedSubStepMessage = (message) => {
        this.setState((prev) => {
            const steps = [...prev.tutorialCodeSteps]
            const stepIdx = prev.selectedTutorialStepIndex
            if (stepIdx < 0 || stepIdx >= steps.length) return null
            const step = { ...steps[stepIdx] }
            const subSteps = [...(step.subSteps || [])]
            const subIdx = prev.selectedTutorialSubStepIndex
            if (subIdx < 0 || subIdx >= subSteps.length) return null
            subSteps[subIdx] = { ...subSteps[subIdx], message }
            step.subSteps = subSteps
            steps[stepIdx] = step
            return { tutorialCodeSteps: steps }
        })
    }

    // ───────── End v2.0 Capture Methods ─────────

    handleHexStepsClear = async () => {
        this.skipHexSyncOnce = true
        sessionStorage.removeItem('currentActiveHexBlock')
        await this.clearProgram()

        this.setState({
            tutorialCodeSteps: [],
            tutorialStepCounter: 0,
            tutorialMeta: {
                tutorialId: '0',
                title: 'Untitled',
                description: 'No description',
            },
            lastPanelStateSnapshot: null,
            currentCapturingStepIndex: -1,
            selectedTutorialStepIndex: 0,
            selectedTutorialSubStepIndex: 0,
            hasSubmittedSteps: false,
            hexInteractionLocked: false,
        })
    }

    handleHexStepsSubmit = async () => {
        const payload = buildTutorialPayload(
            this.state.tutorialCodeSteps,
            this.state.tutorialMeta
        )

        // ---> NEW: Inject the Assembly Screen ID into the final JSON <---
        payload.assemblyScreenId = this.state.selectedAssemblyScreen || ''
        payload.finalStepInstruction1 =
            'Excellent! You have successfully built the logic.'
        payload.finalStepInstruction2 =
            'Please upload the code to see it in action!'

        const BACKEND_URL = process.env.REACT_APP_API_BASE || ''

        // Get Project ID from URL
        let projectId = 'talking-dragon'
        const currentPath = window.location.hash || window.location.pathname
        const pathSegments = currentPath.split('/')
        const adminIndex = pathSegments.indexOf('makeAdmin')
        if (adminIndex !== -1 && pathSegments.length > adminIndex + 1) {
            projectId = pathSegments[adminIndex + 1]
        }

        // Get screenId from URL params (preferred) or URL path
        let screenId = this.props.match?.params?.screenId || ''
        if (!screenId) {
            // Fallback: try to extract from URL: /makeAdmin/:subId/hexAdmin/:screenId
            const hexAdminIndex = pathSegments.indexOf('hexAdmin')
            if (
                hexAdminIndex !== -1 &&
                pathSegments.length > hexAdminIndex + 1
            ) {
                screenId = pathSegments[hexAdminIndex + 1]
            }
        }

        // Build endpoint with screenId if available
        const endpoint = screenId
            ? `${BACKEND_URL}/api/staging/hex/${projectId}/${screenId}`
            : `${BACKEND_URL}/api/staging/hex/${projectId}`

        try {
            const response = await fetch(endpoint, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                credentials: 'include',
            })

            if (!response.ok) throw new Error(`Status: ${response.status}`)
            alert('Coding/Hex tutorial saved successfully to staging!')
            this.setState({ hasSubmittedSteps: true })
        } catch (error) {
            console.error('Failed to save hex steps to staging:', error)
            alert('Error saving to staging. Check console for details.')
        }
    }

    buildProgramWithCoords = (program) => {
        const board = []
        let maxCols = 0
        let curRow = 1
        let curCol = 1

        const addRow = () => {
            board.push([{ type: 'blank' }])
        }

        const ensureRow = () => {
            while (board.length <= curRow) addRow()
        }

        const ensureCol = () => {
            while (board[curRow].length <= curCol) {
                board[curRow].push({ type: 'blank' })
            }
        }

        const setCurCol = (newValue) => {
            curCol = newValue
            if (curCol > maxCols) maxCols = curCol
        }

        const cloneNode = (node) => JSON.parse(JSON.stringify(node || {}))

        const recurse = (instructions) => {
            if (!Array.isArray(instructions) || instructions.length === 0) {
                ensureRow()
                while (board[curRow].length < curCol) {
                    board[curRow].push({ type: 'blank' })
                }
                return []
            }

            return instructions.map((instruction) => {
                const cloned = cloneNode(instruction)

                if (
                    instruction.type === 'variable' ||
                    instruction.type === 'sensor' ||
                    instruction.type === 'condition' ||
                    instruction.type === 'loop'
                ) {
                    curRow += 2
                    ensureRow()
                    if (board[curRow] && board[curRow].length >= curCol) {
                        setCurCol(maxCols + 2)
                    }
                    const innerOldCol = curCol
                    cloned.subprogram = recurse(instruction.subprogram || [])
                    ensureRow()
                    board[curRow].push({ type: 'end_' + instruction.type })
                    curRow -= 2
                    setCurCol(innerOldCol)
                } else if (instruction.subprogram) {
                    cloned.subprogram = recurse(instruction.subprogram)
                }

                ensureRow()
                ensureCol()
                board[curRow][curCol].type = instruction.type
                cloned.row = curRow
                cloned.col = curCol
                setCurCol(curCol + 1)

                return cloned
            })
        }

        addRow()
        addRow()

        return recurse(program || [])
    }

    applyReplayStepDirect = (step) => {
        if (!step || !step.hexState) {
            return
        }

        const nextLogic = step.hexState.logicTwoContent
            ? JSON.parse(JSON.stringify(step.hexState.logicTwoContent))
            : this.props.logic

        if (step.hexState.currentActiveHexBlock) {
            sessionStorage.setItem(
                'currentActiveHexBlock',
                JSON.stringify(step.hexState.currentActiveHexBlock)
            )
            if (nextLogic && nextLogic.bottomPanel !== 'show') {
                nextLogic.bottomPanel = 'show'
            }
        } else {
            sessionStorage.removeItem('currentActiveHexBlock')
        }

        this.props.update(nextLogic)
    }

    showReplayMessage = (message) => {
        this.setState({ replayMessage: message })
    }

    handleHexStepsPlay = () => {
        if (this.state.isReplaying) {
            return
        }

        if (
            !window.confirm(
                'Have you saved all your changes? Unsaved changes will be lost. Click OK to continue and preview the last saved version.'
            )
        )
            return

        // 1. Start with a fallback
        let projectId = 'talking-dragon'

        // 2. Try to get it from React Router first
        if (this.props.match?.params?.subId) {
            projectId = this.props.match.params.subId
        } else {
            // 3. Fallback: Parse the URL directly (handles both Hash routing and standard routing)
            const currentPath = window.location.hash || window.location.pathname
            const pathSegments = currentPath.split('/') // Splits into ["", "makeAdmin", "dummy", "hexAdmin"]

            // Find the index of 'makeAdmin' and grab the very next segment
            const adminIndex = pathSegments.indexOf('makeAdmin')
            if (adminIndex !== -1 && pathSegments.length > adminIndex + 1) {
                projectId = pathSegments[adminIndex + 1]
            }
        }

        console.log('Previewing Hex Steps for Project ID:', projectId)

        // 4. Push to the logic screen with the dynamically extracted ID
        this.props.history.push({
            pathname: '/logicTwo',
            search: `?preview=true&projectId=${projectId}`,
        })
    }

    handleHexStepsFileSelect = (event) => {
        const file = event.target.files && event.target.files[0]
        if (!file) {
            return
        }

        const reader = new FileReader()
        reader.onload = () => {
            try {
                const payload = JSON.parse(reader.result)

                // v2.0 format: has codeSteps array
                if (
                    payload.version === '2.0' &&
                    Array.isArray(payload.codeSteps)
                ) {
                    this.startReplayV2(payload)
                    return
                }

                // Legacy v1.0 format: has steps array
                if (Array.isArray(payload?.steps) && payload.steps.length) {
                    this.startReplayFromSteps(payload.steps)
                    return
                }

                this.setState({ replayMessage: 'No steps found in file.' })
            } catch (error) {
                console.error('Failed to parse steps file:', error)
                this.setState({ replayMessage: 'Invalid steps file.' })
            } finally {
                event.target.value = ''
            }
        }

        reader.readAsText(file)
    }

    startReplayV2 = (tutorialData) => {
        if (this.state.isReplaying) return

        const microSlides = flattenToMicroSlides(tutorialData)
        if (!microSlides.length) {
            this.setState({ replayMessage: 'No steps to replay.' })
            return
        }

        if (this.replayTimerId) {
            clearTimeout(this.replayTimerId)
            this.replayTimerId = null
        }

        // Reset to default program
        this.skipHexSyncOnce = true
        this.props.update(JSON.parse(JSON.stringify(defaultLogic)))
        sessionStorage.removeItem('currentActiveHexBlock')

        this.setState({
            isReplaying: true,
            replayIndex: 0,
            replayMessage: '',
            tutorialRecording: false,
        })

        const codeSteps = tutorialData.codeSteps

        const playNext = (slideIndex) => {
            if (slideIndex >= microSlides.length) {
                this.setState({
                    isReplaying: false,
                    replayMessage: 'Replay complete!',
                    tutorialRecording: true,
                })
                return
            }

            const slide = microSlides[slideIndex]
            const { logic, currentActiveHexBlock } = buildStateForMicroSlide(
                codeSteps,
                slide
            )

            this.skipHexSyncOnce = true
            this.props.update(JSON.parse(JSON.stringify(logic)))

            if (currentActiveHexBlock) {
                sessionStorage.setItem(
                    'currentActiveHexBlock',
                    JSON.stringify(currentActiveHexBlock)
                )
            } else {
                sessionStorage.removeItem('currentActiveHexBlock')
            }

            this.setState({
                replayIndex: slideIndex,
                replayMessage: slide.instruction || slide.title || '',
            })

            this.replayTimerId = setTimeout(() => {
                playNext(slideIndex + 1)
            }, 3000)
        }

        console.log('Starting v2.0 replay:', microSlides.length, 'micro-slides')
        playNext(0)
    }

    startReplayFromSteps = (steps) => {
        if (this.state.isReplaying) {
            return
        }

        if (!Array.isArray(steps) || steps.length === 0) {
            this.setState({ replayMessage: 'No steps to replay.' })
            return
        }

        if (this.replayTimerId) {
            clearTimeout(this.replayTimerId)
            this.replayTimerId = null
        }

        this.setState({ isReplaying: true, replayIndex: 0, replayMessage: '' })

        const playNext = async (index) => {
            if (index >= steps.length) {
                this.setState({ isReplaying: false, replayMessage: '' })
                return
            }

            const step = steps[index]
            if (step?.hexState) {
                this.applyReplayStepDirect(step)
            }
            this.setState({ replayIndex: index })

            this.replayTimerId = setTimeout(() => {
                playNext(index + 1)
            }, 5000)
        }

        playNext(0)
    }

    //read data from serial worker
    messageHandler = (e) => {
        // if (e.data.type === 'read' && e.data.value.includes('AISOK')) {
        //     const doneObj = { sendDataAsPacket: true, readVal: 'AISOK' }
        //     this.sendDataRef.current = doneObj
        // } else if (e.data.type === 'read' && e.data.value.includes('AIROK')) {
        //     const doneObj = { sendDataAsPacket: true, readVal: 'AIROK' }
        //     this.sendDataRef.current = doneObj
        // } else
        if (e.data.type === 'read' && e.data.value.includes('OK')) {
            const doneObj = { sendDataAsPacket: true, readVal: 'OK' }
            this.sendDataRef.current = doneObj
        }
        if (e.data.type === 'actionRead') {
            let { arrayData, stringData } = e.data.value
            const pattern = /^65,73,.*255,245$/
            const isPatternMatch = pattern.test(arrayData.join(','))
            if (isPatternMatch) {
                this.sendDataRef.current = {
                    sendDataAsPacket: true,
                    readVal: arrayData,
                }
            }
        }
    }

    timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                while (true) {
                    // let sendData_read = sessionStorage.getItem('sendData_read')
                    let sendData_read = this.sendDataRef.current
                    if (sendData_read) {
                        // sendData_read = JSON.parse(sendData_read)
                        if (sendData_read.sendDataAsPacket) {
                            return resolve(sendData_read.readVal)
                        }
                    }

                    await new Promise((reslove) => {
                        setTimeout(reslove, 100)
                    })
                }
            } catch (e) {
                console.log(e)
            }
        })
    }

    constraintOffset = (offset) => {
        var el = document.getElementById('logicOffsetTransformer', this.props)
        const BBox = el.getBBox()
        const { height, width } = this.props.assembly
        const scale = this.props.logic.scale * defaultScale
        if (offset.left * scale > width / 2) offset.left = width / (2 * scale)
        else if (offset.left < -BBox.width + width / (2 * scale))
            offset.left = -BBox.width + width / (2 * scale)
        if (offset.top * scale > height / 2) offset.top = height / (2 * scale)
        else if (offset.top < -BBox.height + height / (2 * scale))
            offset.top = -BBox.height + height / (2 * scale)
    }

    /**
     * Pan event handler : does not update state for smooth panning. Also throttles the event
     */
    pan = (e) => {
        if (panning) return
        panning = true
        var el = document.getElementById('logicOffsetTransformer')
        var BBox = el.getBBox()
        const { offset } = this.props.logic

        const { height, width } = this.props.assembly

        finalOffset.left = offset.left + e.deltaX
        finalOffset.top = offset.top + e.deltaY
        if (finalOffset.left > width / 2) finalOffset.left = width / 2
        else if (finalOffset.left < -BBox.width + width / 2)
            finalOffset.left = -BBox.width + width / 2
        if (finalOffset.top > height / 2) finalOffset.top = height / 2
        else if (finalOffset.top < -BBox.height + height / 2)
            finalOffset.top = -BBox.height + height / 2
        el.setAttribute(
            'transform',
            'translate(' + finalOffset.left + ',' + finalOffset.top + ')'
        )
        panning = false
    }

    /**
     * Set dontTriggerClick variable to true
     */
    panStart = () => {
        dontTriggerClick = true
    }
    /**
     * Update state variables
     */
    panEnd = (e) => {
        var { logic } = this.props
        logic.offset.left = finalOffset.left
        logic.offset.top = finalOffset.top
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic, () => (panning = false))
    }
    panEndNew = () => {
        panning = false
        oldDeltaX = 0
        oldDeltaY = 0
    }

    zoom = (scale, clientX, clientY) => {
        var { height, width } = this.props.assembly
        var { logic } = this.props
        var clientY = height
        if (zooming) return
        var { height, width } = this.props.assembly
        var { logic } = this.props
        var clientY = height

        if ((logic.scale < 0.5 && scale < 1) || (logic.scale > 2 && scale > 1))
            return
        // zooming = true;
        var clientY = height
        // client = (offset + x/y) * scale
        // client of oldx/y = client of newx/y (current mouse position)
        // oldx/y = client / scale - offset
        // (newoffset + oldx/y) * newscale = (oldOffset + oldx/y) * oldscale
        const oldX = clientX / (logic.scale * defaultScale) - logic.offset.left

        const oldY = clientY / (logic.scale * defaultScale) - logic.offset.top
        logic.offset.left = (logic.offset.left + oldX) / scale - oldX
        logic.offset.top = (logic.offset.top + oldY) / scale - oldY

        logic.scale *= scale

        this.constraintOffset(logic.offset)
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic, () => {
            zooming = false
        })
    }

    /**
     * Pinch Out event handler
     */
    pinchOut = (e) => {
        this.zoom(6 / 5, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }

    /**
     * Pinch In event handler
     */
    pinchIn = (e) => {
        this.zoom(5 / 6, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    pinchOutNew = (e) => {
        this.zoomNew(12 / 11, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    /**
     * Pinch In event handler
     */
    pinchInNew = (e) => {
        this.zoomNew(11 / 12, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    /**
     * Reset pinch variables
     */
    pinchEnd = () => {
        zooming = false
    }
    /**
     * Wheel event handler
     */
    wheel = (e) => {
        // e.preventDefault();
        const { clientX, clientY, deltaY } = e
        if (deltaY > 0) {
            this.zoom(5 / 6, clientX, clientY)
        } else {
            this.zoom(6 / 5, clientX, clientY)
        }
        return false
    }
    wheelNew = (e) => {
        const { clientX, clientY, deltaY } = e
        if (deltaY > 0) this.zoomNew(5 / 6, clientX, clientY)
        else this.zoomNew(6 / 5, clientX, clientY)
        // e.preventDefault();
        return false
    }

    click = (row, col) => {
        //         if (this.state.hexInteractionLocked) {
        //             window.alert(
        //     'Only the instructions in the dialog below can be edited. The program can be viewed using pan and zoom, but cannot be modified. To make changes, please click "Clear" and start over.'
        // )
        //             return
        //         }
        // alert("CLICK");
        // alert(window.event.clientX)
        // IDIS = `${1}${col}`;
        // IDIS = window.event.clientX*window.event.clientY;

        if (dontTriggerClick) {
            dontTriggerClick = false
            return
        }
        var { logic } = this.props

        const { currentProgramGuide } = logic

        var todo = 'current'

        logic.insertState = false

        const { type } = drawing.board[row][col]

        if (type === 'blank' || type === 'hand' || type === 'highlighted_hand')
            todo = 'blank'

        if (todo === 'current') {
            logic.active = [row, col]

            drawing = ProgramToDrawing(
                undefined,
                logic.program,
                logic.end,
                logic.currentProgramGuide,
                logic.active,
                this.add,
                logic.insertState,
                this.insertNode,
                this.insertBtwnNode,
                this.deleteNode,
                this.click
            )

            var logicState = {}
            this.props.update(logic)
        } else if (todo === 'blank') {
            logic.active = [-1, -1]

            // Uncomment the following line to auto-minimize bottomPanel on blank space click
            // logic.bottomPanel = 'border';
            drawing = ProgramToDrawing(
                undefined,
                logic.program,
                logic.end,
                logic.currentProgramGuide,
                logic.active,
                this.add,
                logic.insertState,
                this.insertNode,
                this.insertBtwnNode,
                this.deleteNode
            )

            var logicState = {}
            logicState['type'] = this.state.currentLogicScreen
            logicState['state'] = logic

            this.props.update(logic)
        }
    }
    recurseAdd = (instructions, nesting, toPush) => {
        // alert("RECURSE_ADD");

        if (instructions.length !== 0) {
            if (nesting === 0) {
                instructions.push(toPush)
            } else {
                this.recurseAdd(
                    instructions[instructions.length - 1].subprogram,
                    nesting - 1,
                    toPush
                )
            }
        }
    }
    add = (type) => {
        if (this.state.hexInteractionLocked) {
            window.alert(
                'Only the instructions in the dialog below can be edited. The program can be viewed using pan and zoom, but cannot be modified. To make changes, please click "Clear" and start over.'
            )
            return
        }
        // alert("ADD()");
        var { logic } = this.props
        console.log('logic: ', logic)
        console.log('checking add', type)
        if (type == 'repeat' || type == 'end') {
            this.setState({ readyForSimulation: type })
            sessionStorage.setItem('programEnd', type)
        }

        if (dontTriggerClick) {
            dontTriggerClick = false
            return
        }

        // 🚨 1. CAPTURE THE EXACT GRID POSITION OF THE 'SELECT' BLOCK BEFORE RESETTING
        const exactRow = logic.active[0] !== -1 ? logic.active[0] : null
        const exactCol = logic.active[1] !== -1 ? logic.active[1] : null

        var { logic } = this.props

        logic.active = [-1, -1]

        // console.log("logic.program new", logic.program, type)

        if (
            type === 'end_variable' ||
            type === 'end_sensor' ||
            type === 'end_condition' ||
            type === 'end_if' ||
            type === 'end_loop'
            // ||
            // type === "repeat"
        ) {
            logic.currentProgramGuide--
            // 🚨 2. PASS EXACT COORDINATES TO CAPTURE
            this.captureBlockPlaced(
                type,
                logic.currentProgramGuide,
                exactRow,
                exactCol
            )
        } else {
            var toPush = { type: type, state: {} }

            if (
                type === 'variable' ||
                type === 'sensor' ||
                type === 'condition' ||
                type === 'loop'
            )
                toPush.subprogram = []

            this.recurseAdd(logic.program, logic.currentProgramGuide, toPush)

            // 🚨 3. PASS EXACT COORDINATES TO CAPTURE
            this.captureBlockPlaced(
                type,
                logic.currentProgramGuide,
                exactRow,
                exactCol
            )

            if (
                type === 'variable' ||
                type === 'sensor' ||
                type === 'condition' ||
                type === 'loop'
            )
                logic.currentProgramGuide++
        }

        drawing = ProgramToDrawing(
            type,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add
        )
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)

        saveToLocalStorage()
    }

    /////////////// HUMANOID FUNCTION /////////////
    addUniqueId = (program, type) => {
        if (
            ['Ace', 'Roboki', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        )
            return

        // Guard: this is humanoid-only data. If it isn't present (e.g. Poki
        // and other non-humanoid boards), there is nothing to attach — bail
        // out instead of letting JSON.parse('') throw "Unexpected end of JSON
        // input", which would freeze the block-insert click handler.
        const humanoidPortDataRaw = sessionStorage.getItem('humanoidPortData')
        if (!humanoidPortDataRaw) {
            return
        }

        let humanoidPortData
        let humanoidProgramData
        try {
            humanoidPortData = JSON.parse(humanoidPortDataRaw)
            humanoidProgramData = JSON.parse(
                sessionStorage.getItem('humanoidProgramData') || '{}'
            )
        } catch (e) {
            console.error('addUniqueId: invalid humanoid data', e)
            return
        }

        if (!humanoidPortData) {
            return
        }

        let newNodeId = parseInt(sessionStorage.getItem('nodeCounter')) || 0
        newNodeId += 1
        sessionStorage.setItem('nodeCounter', newNodeId)

        let stateData = {}
        Object.entries(humanoidPortData).map((port) => {
            stateData[port[0]] = {
                name: humanoidPortData[port[0]].name,
                value: humanoidPortData[port[0]].value,
                isActionEnabled: humanoidPortData[port[0]].isActionEnabled,
                isLiveBtnActive: false,
            }
            // if([''].includes(port[0]))
        })

        //add the isRandomActionSelected in actionGroup state
        if (
            ['Humanoid', 'Hexapod'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        ) {
            stateData['4a'].isRandomActionSelected = false
        }

        let node = {
            id: newNodeId,
            type: type,
            state: stateData,
        }
        if (type == 'condition') node.state = { port: '', value: 0, value1: 0 }

        sessionStorage.setItem(
            'humanoidProgramData',
            JSON.stringify({ ...humanoidProgramData, [node.id]: node })
        )

        this.findAndAttachNewId(program, newNodeId)
    }

    /////////////// HUMANOID FUNCTION /////////////
    findAndAttachNewId = (program, newNodeId) => {
        for (let node = 0; node < program.length; node++) {
            // newNodeId is attached to that node which doesn't have an id yet.
            // At any point, only the newly created node will not have an id and that's how we find the newNode.
            // This nodeId is also the key for each object in *humanoidProgramData*.
            if (
                program[node].nodeId === undefined &&
                (program[node].type === 'hardware' ||
                    program[node].type === 'condition' ||
                    program[node].type === 'sensor')
            ) {
                program[node].nodeId = newNodeId
                break
            }
            if (
                program[node].type === 'condition' ||
                program[node].type === 'sensor' ||
                program[node].type === 'loop'
            ) {
                this.findAndAttachNewId(program[node].subprogram, newNodeId)
            }
        }
    }

    insertNode = (type) => {
        if (this.state.hexInteractionLocked) {
            window.alert(
                'Only the instructions in the dialog below can be edited. The program can be viewed using pan and zoom, but cannot be modified. To make changes, please click "Clear" and start over.'
            )
            return
        }
        // for(let n = 0; n<drawing.activeParentRef.slice(drawing.activeIndex, drawing.activeParentRef.length).length; n++){
        //   drawing.activeParentRef[n].id= JSON.stringify(Number(drawing.activeParentRef[n].id) + 1)
        // }
        num++

        var { logic } = this.props

        // if (!logic.insertState) {
        //   logic.insertState = true;
        // } //removed by gautam to change to single click
        if (type == null) {
            logic.insertState = true
        } else {
            // this condition is for the  render the bolck wait click it action and then wait hadrware panke will open
            if (type != 'action') {
                logic.insertState = false
                var temp = drawing.activeParentRef[drawing.activeIndex]

                // HERE I AM STOPING TO ADD THE ACTION on HEXBOARD

                var toPush = { type: type, state: {}, id: IDIS }
                if (
                    type === 'end_variable' ||
                    type === 'end_sensor' ||
                    type === 'end_condition' ||
                    type === 'end_if' ||
                    type === 'end_loop'
                    // ||
                    // type === "repeat"
                ) {
                    logic.currentProgramGuide--
                }
                if (
                    type === 'variable' ||
                    type === 'condition' ||
                    type === 'sensor' ||
                    type === 'loop' ||
                    type === 'if'
                ) {
                    logic.currentProgramGuide++
                    toPush.subprogram = []
                }
                drawing.activeParentRef[drawing.activeIndex] = toPush

                for (
                    let i = drawing.activeIndex + 1;
                    i < drawing.activeParentRef.length;
                    i++
                ) {
                    var temp2 = drawing.activeParentRef[i]
                    drawing.activeParentRef[i] = temp
                    temp = temp2
                }
                if (temp) drawing.activeParentRef.push(temp)
                logic.active = [-1, -1]

                logic.program.map((i, id) => {
                    i.id = `${1}${id}`
                })

                /////////////////////////////////////////////
                ///////////// Humanoid code /////////////////
                if (type === 'hardware' || type === 'condition') {
                    this.addUniqueId(logic.program, type)
                }
                /////////// Humanoid code ends //////////////
                /////////////////////////////////////////////

                // ★ Capture PLACE_BLOCK for inserted node
                this.captureBlockInserted(type, toPush)
            }
        }

        drawing = ProgramToDrawing(
            type,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    insertBtwnNode = (type) => {
        if (this.state.hexInteractionLocked) {
            window.alert(
                'Only the instructions in the dialog below can be edited. The program can be viewed using pan and zoom, but cannot be modified. To make changes, please click "Clear" and start over.'
            )
            return
        }
        // for(let n = 0; n<drawing.activeParentRef.slice(drawing.activeIndex, drawing.activeParentRef.length).length; n++){
        //   drawing.activeParentRef[n].id= JSON.stringify(Number(drawing.activeParentRef[n].id) + 1)
        // }
        num++

        var { logic } = this.props
        console.log('checkingvalues', type)
        // if (!logic.insertState) {
        //   logic.insertState = true;
        // } //removed by gautam to change to single click
        if (type == null) {
            logic.insertState = true
        } else {
            // this condition is for the  render the bolck wait click it action and then wait hadrware panke will open
            if (type != 'action') {
                logic.insertState = false
                // Save insert position before shifting
                var insertIndex = drawing.activeIndex
                var insertParentRef = drawing.activeParentRef
                var temp = drawing.activeParentRef[drawing.activeIndex]

                // HERE I AM STOPING TO ADD THE ACTION on HEXBOARD

                var toPush = { type: type, state: {}, id: IDIS, newId: num }

                if (
                    type === 'variable' ||
                    type === 'condition' ||
                    type === 'sensor' ||
                    type === 'loop' ||
                    type === 'if'
                ) {
                    // logic.currentProgramGuide++;
                    toPush.subprogram = []
                }
                drawing.activeParentRef[drawing.activeIndex] = toPush

                for (
                    let i = drawing.activeIndex + 1;
                    i < drawing.activeParentRef.length;
                    i++
                ) {
                    var temp2 = drawing.activeParentRef[i]
                    drawing.activeParentRef[i] = temp
                    temp = temp2
                }
                if (temp) drawing.activeParentRef.push(temp)
                logic.active = [-1, -1]

                logic.program.map((i, id) => {
                    i.id = `${1}${id}`
                })

                /////////// Humanoid code ////////////////////
                if (type === 'hardware' || type === 'condition') {
                    this.addUniqueId(logic.program, type)
                }

                // ★ Capture INSERT_BLOCK for inserted-between node
                this.captureBlockInsertedBetween(
                    type,
                    insertIndex,
                    insertParentRef
                )
            }
        }

        drawing = ProgramToDrawing(
            type,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    deleteNode = () => {
        if (this.state.hexInteractionLocked) {
            window.alert(
                'Only the instructions in the dialog below can be edited. The program can be viewed using pan and zoom, but cannot be modified. To make changes, please click "Clear" and start over.'
            )
            return
        }
        var { logic } = this.props

        // ★ Capture DELETE_BLOCK before the node is removed
        var deletedType = drawing.activeRef ? drawing.activeRef.type : 'unknown'
        var deletedIndex = drawing.activeIndex
        var deletedParentRef = drawing.activeParentRef
        var deletedGridPos = { row: 1, col: 1 }
        try {
            var positions = computeAllBlockPositions(logic.program)
            var match = positions.find((p) => p.ref === drawing.activeRef)
            if (match) deletedGridPos = { row: match.row, col: match.col }
        } catch (e) {}

        ////////////////// PLAYC-71 ////////////////////
        /// Active Hand lost after removing loop ///////

        if (
            drawing.activeRef.type == 'repeat' ||
            drawing.activeRef.type == 'end'
        ) {
            sessionStorage.removeItem('PET')
            sessionStorage.removeItem('EndSwitch')
        }

        /////////////////////////////////////////////////

        if (
            drawing.activeParentRef.length - 1 == drawing.activeIndex &&
            (drawing.activeRef.type === 'variable' ||
                drawing.activeRef.type === 'sensor' ||
                drawing.activeRef.type === 'condition' ||
                drawing.activeRef.type === 'loop')
        ) {
            let currentProgramGuide = 0,
                temp = logic.program
            while (
                temp != drawing.activeParentRef &&
                currentProgramGuide < logic.currentProgramGuide
            ) {
                temp = temp[temp.length - 1].subprogram
                currentProgramGuide++
            }
            if (currentProgramGuide < logic.currentProgramGuide)
                logic.currentProgramGuide = currentProgramGuide
        }

        if (drawing.activeRef.type === 'end') {
            logic.currentProgramGuide = 0
        }
        // alert(drawing.activeIndex)
        drawing.activeParentRef.splice(drawing.activeIndex, 1)
        logic.active = [-1, -1]

        // ★ Capture the deletion after splice (nestingPath computed against modified program)
        this.captureBlockDeleted(
            deletedType,
            deletedIndex,
            deletedParentRef,
            deletedGridPos
        )

        drawing = ProgramToDrawing(
            undefined,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    toggleBottomPanel = async (e, nodeId) => {
        if (this.state.hexInteractionLocked) {
            window.alert(
                'Only the instructions in the dialog below can be edited. The program can be viewed using pan and zoom, but cannot be modified. To make changes, please click "Clear" and start over.'
            )
            return
        }
        //if click on live buttn that time you can not close the panel, because the zing and hexapod v1,
        //sending the setting bytes, after 2.3 sec again we send the bytes, other waise it does not worke
        if (this.props.concept?.disableAfterSettingByt) {
            return
        }

        if (sessionStorage.getItem('isReadingZingPA') == 'true') {
            sessionStorage.setItem('isReadingZingPA', false)
            continousPABytesReadToggle(
                null,
                null,
                this.props.webSerial.port,
                null,
                'OFF'
            )
        }

        var { logic, logicEditor, update } = this.props
        var endchek = true
        console.log('endchek', e, nodeId)
        try {
            if (e.includes('end_')) {
                endchek = false
            }
        } catch (error) {}

        if (endchek) {
            if (logic.bottomPanel === 'show') {
                logic.bottomPanel = 'border'
                // ★ Capture CLOSE_MENU
                this.capturePanelClosed()
                // console.log('VVVVVVVVVVVV1111', drawing.activeRef.type)
                //disabled all live button when close the action panel
                if (drawing.activeRef.type === 'hardware') {
                    let newState = drawing.activeRef.state
                    let isDisableCustomactionButton = false

                    //send the PLAY bytes to stop the all live  output, if live output enable
                    if (
                        Object.keys(newState).some((objKey) => {
                            if (objKey.includes('liveBtn')) {
                                return newState[objKey]
                            } else return false
                        })
                    ) {
                        const connectedDevice =
                            sessionStorage.getItem('connectedDevice')
                        const deviceVersion =
                            sessionStorage.getItem('deviceVersion')

                        let sendStopBytes = stopByteCondition({
                            connectedDevice,
                            deviceVersion,
                        })

                        setTimeout(() => {
                            this.props.worker.postMessage({
                                type: 'writeArray',
                                value: sendStopBytes,
                            })
                        }, 100)
                    }

                    //for zing klaw hexapod desabled the liveBtn
                    if (
                        ['Klaw', 'Humanoid', 'Hexapod'].includes(
                            sessionStorage.getItem('connectedDevice')
                        )
                    ) {
                        let humanoidProgramData = {}
                        let humanoidProgramDataId = drawing.activeRef.nodeId
                        try {
                            humanoidProgramData = JSON.parse(
                                sessionStorage.getItem('humanoidProgramData')
                            )
                        } catch (e) {
                            console.log('ERROR', e)
                        }
                        let humanoidProgramDataState =
                            humanoidProgramData[humanoidProgramDataId].state

                        if (
                            humanoidProgramDataState?.['4a']?.value === '74' &&
                            !humanoidProgramDataState?.['4a']
                                ?.isRandomActionSelected
                        ) {
                            humanoidProgramDataState['4a'].value = 0
                            isDisableCustomactionButton = true
                        }
                        for (const objKey of Object.keys(
                            humanoidProgramDataState
                        )) {
                            if (
                                humanoidProgramDataState[objKey]
                                    ?.isLiveBtnActive
                            ) {
                                humanoidProgramDataState[
                                    objKey
                                ].isLiveBtnActive = false
                            }

                            //set the defolt postion for serial servo zing and hexapod
                            if (
                                humanoidProgramDataState[objKey]?.isLiveSActive
                            ) {
                                let PORTDATAKey = generateDeviceDataKey(
                                    sessionStorage.getItem('connectedDevice'),
                                    sessionStorage.getItem('deviceVersion')
                                )
                                let defaultServoValue =
                                    PORTDATA[PORTDATAKey]?.[objKey]?.value
                                if (defaultServoValue) {
                                    let servoFeedbackBytes = [
                                        'S'.charCodeAt(0),
                                        'M'.charCodeAt(0),
                                        parseInt(objKey - 4),
                                    ]
                                    let MSBLSB =
                                        decimalToMSBLSB(defaultServoValue)
                                    servoFeedbackBytes.push(
                                        MSBLSB[0],
                                        MSBLSB[1]
                                    )

                                    this.props.worker.postMessage({
                                        type: 'writeArray',
                                        value: servoFeedbackBytes,
                                    })
                                }
                                humanoidProgramDataState[objKey].isLiveSActive =
                                    false

                                await new Promise((reslove) =>
                                    setTimeout(reslove, 100)
                                )
                            }
                        }

                        sessionStorage.setItem(
                            'humanoidProgramData',
                            JSON.stringify(humanoidProgramData)
                        )

                        //--------------------------------------------
                        const updateLogicProgram = (program) => {
                            for (let node = 0; node < program.length; node++) {
                                if (
                                    program[node].nodeId ===
                                    drawing.activeRef.nodeId
                                ) {
                                    //set false custom action button in redux
                                    if (isDisableCustomactionButton) {
                                        program[node].state.assignCustomAction =
                                            false
                                    }

                                    // program[node].state = newState
                                    Object.keys(program[node].state).map(
                                        (objKey) => {
                                            if (objKey.includes('liveBtn')) {
                                                program[node].state[objKey] =
                                                    false
                                            }
                                        }
                                    )
                                    break
                                }
                                if (
                                    program[node].type === 'condition' ||
                                    program[node].type === 'sensor' ||
                                    program[node].type === 'loop'
                                ) {
                                    updateLogicProgram(program[node].subprogram)
                                }
                            }
                        }
                        updateLogicProgram(logic.program)
                        ///-------------
                    } else {
                        Object.keys(newState).map((objKey) => {
                            if (objKey.includes('liveBtn')) {
                                newState[objKey] = false
                            }
                        })
                    }

                    // drawing.activeRef.state = newState
                }
            } else {
                logic.bottomPanel = 'show'
                // ★ Capture OPEN_MENU
                this.capturePanelOpened()
            }
        }

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        var logicToBeChanged
        // if (this.state.currentLogicScreen == "hexa") {
        logicToBeChanged = logic
        // } else if (this.state.currentLogicScreen == "flow") {
        //   logicToBeChanged = logicNew;
        // }
        // else if (this.state.currentLogicScreen == "python") {
        //   logicToBeChanged = pythonEditor;
        // } else {
        //   logicToBeChanged = logicEditor;
        // }

        logicState['state'] = logicToBeChanged

        this.props.update(logic)
    }
    /* 
    function to recursively delete start keys which are false and are 
    present in other nodes of the program.
  */
    bottomPanelDelete = (key) => {
        var { logic } = this.props
        var search = key
        function recursiveDeleteFromObject(search, OBJ) {
            for (var key in OBJ) {
                if (!(key == search) && typeof OBJ[key] === 'object') {
                    recursiveDeleteFromObject(search, OBJ[key])
                } else {
                    if (key == search) {
                        delete OBJ[key]
                    }
                }
            }
            return OBJ
        }
        function recursiveDeleteFromArrayObject(search, Arr_OBJ) {
            for (var key in Arr_OBJ) {
                Arr_OBJ[key] = recursiveDeleteFromObject(search, Arr_OBJ[key])
            }
            return Arr_OBJ
        }
        var result = recursiveDeleteFromArrayObject(search, logic.program)
        logic.program = result
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    bottomPanelChange = (state, type) => {
        var { logic } = this.props

        if (type) {
            drawing.activeRef.type = type
        }
        // if (state) {
        drawing.activeRef.state = state
        if (state == 'end') {
            drawing.activeRef.type = 'end'
            sessionStorage.setItem('EndSwitch', 'end')
        }
        if (state == 'repeat') {
            drawing.activeRef.type = 'repeat'
            sessionStorage.removeItem('EndSwitch')
        }
        // }

        // ★ Capture value changes (debounced via functional setState)
        this.captureValueChanged(state)

        if (drawing.activeRef.type === 'end')
            console.log('bottomPanelChange end')

        drawing = ProgramToDrawing(
            undefined,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add
        )
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic
        this.props.update(logic)
        saveToLocalStorage()
    }

    handleBottomPanelClick = () => {
        var { logic } = this.props
        if (logic.bottomPanel === 'show') {
            logic.bottomPanel = 'border'
            dontTriggerClick = true
        }
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
    }

    seperateClicked = () => {
        // $(document).ready(function =()=>{
        //   $(".hide").click(function =()=>{
        //     $("p").hide();
        //   });
        //   $(".show").click(function =()=>{
        //     $("p").show();
        //   });
        // });
    }

    clickmeUp = () => {
        var { logic } = this.props
        if (logic.bottomPanel != 'show') logic.bottomPanel = 'show'
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
    }
    clickmeDown = () => {
        var { logic } = this.props
        if (logic.bottomPanel === 'show') logic.bottomPanel = 'border'
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
    }

    setCurrentNode(current, index) {
        this.setState({ currentNode: current, currentNodeIndex: index })
    }

    showSetting = () => {
        document.getElementById('divH').style.display = 'inline'
    }
    closeSetting = () => {
        document.getElementById('divH').style.display = 'none'
        document.getElementById('divH1').style.display = 'none'
    }
    showConverter = () => {
        document.getElementById('divH1').style.display = 'block'
    }

    Save = () => {
        // console.log("SAVE==>");
    }

    close = () => {
        this.setState({ modalIsOpen: false })
    }

    closeUpload = () => {
        this.setState({ uploadOpen: false })
    }
    closeUsb = () => {
        this.setState({ usbOpen: false })
    }
    closeUploadSucess = () => {
        this.setState({ uploadSucessError: { isShow: false, message: '' } })
    }
    check = () => {
        const logicTwoContent = JSON.parse(
            sessionStorage.getItem('logicTwoContent') || '{}'
        )
        var program = logicTwoContent.program
        var end = logicTwoContent.end
        var upldbtn = document.getElementById('uploadLogicscrn')
        upldbtn.style.pointerEvents = 'none'
        upldbtn.style.cursor = 'not-allowed'

        this.setState({ uploadOpen: true })
        setTimeout(() => {
            upldbtn.style.cursor = 'pointer'

            upldbtn.style.pointerEvents = 'all'

            this.setState({ uploadOpen: false })
        }, 5000)

        //var socket = socketIOClient("http://localhost:3008");
        if (localStorage.getItem('programMode') == 'learn') {
            // socket.emit("/checkLogic", program, end, "Final");
            // socket.on("/logicResult", (data) => {
            //   if (!data) {
            //     this.setState({ modalIsOpen: true });
            //     return true;
            //   } else {
            //     var params = {
            //       screen: "hexa",
            //       logic: this.props.logic,
            //       components: this.props.assembly.PortConnections,
            //     };
            //     var Peripherial = JSON.parse(localStorage.getItem("Bluetooth"));
            //     // console.log("this.props.history DONE LOGIC", Peripherial[0]["mac"])
            //     if (Peripherial) {
            //       socket.emit("/upload", { code: params }, Peripherial[0]["mac"]);
            //     } else {
            //       socket.emit("/upload", { code: params });
            //     }
            //     socket.on("_upload", (data) => {
            //       // this.setState({ modalIsOpen: true })
            //     });
            //     return false;
            //     // this.props.history.push("/Learn")
            //   }
            // });
        } else {
            var params = {
                screen: 'hexa',
                logic: this.props.logic,
                components: this.props.assembly.PortConnections,
            }
            var Peripherial = JSON.parse(localStorage.getItem('Bluetooth'))
            // console.log("this.props.history DONE LOGIC", Peripherial[0]["mac"])

            // if (Peripherial) {
            //   socket.emit("/upload", { code: params }, Peripherial[0]["mac"]);
            // } else {
            //   socket.emit("/upload", { code: params });
            // }

            // socket.on("_upload", (data) => {
            //   // this.setState({ modalIsOpen: true })
            // });
            return false
            // this.props.history.push("/Learn")
        }
    }
    tutor = () => {
        this.props.history.push('/saveTutorials')
    }
    hexTypeCheck = (value) => {
        this.setState({ hexType: value })
    }
    if = (value) => {
        return (
            <div>
                Click on the hand hex and click on action hex ,double click the
                action hex and select {value.type}{' '}
                {
                    ((
                        <div>
                            {' '}
                            Set{' '}
                            {Object.entries(value.state).map(([key, value]) => {
                                return (
                                    <span>
                                        {' '}
                                        {key} {value}
                                    </span>
                                )
                            })}
                        </div>
                    ),
                    (
                        <div>
                            {' '}
                            Down to {value.type}{' '}
                            {value.subprogram
                                ? value.subprogram.map((value, index) => {
                                      return value.type == 'hardware' ||
                                          value.type == 'variable' ||
                                          value.type == 'wait'
                                          ? this.output(value)
                                          : value.type == 'sensor' ||
                                              value.type == 'variable'
                                            ? this.if(value)
                                            : ''
                                      // return <div>{index}{value.type}</div>
                                  })
                                : ''}
                        </div>
                    ))
                }
            </div>
        )
    }
    output = (value) => {
        var hardware = []
        var keyValueArray = []
        var keyTypeArray = []
        var keyValue
        var keyType
        if (value.type == 'hardware') {
            hardware.push('Click on the hand icon and select Action ')
            hardware.push('Double Click and select hardware ')
            Object.entries(value.state).map(([key, value]) => {
                // return (<span> {key} {value}</span>)
                // var key1 = key[
                // var value1 = key["value"]
                if (key.includes('assign')) {
                    keyType = key.split('gn')
                    keyTypeArray.push(keyType[1])
                }

                if (key.includes('value')) {
                    keyValue = key.split('ue')
                }

                for (let i = 0; i < keyTypeArray.length; i++) {
                    if (keyValue) {
                        if (keyValue[1] == keyTypeArray[i]) {
                            keyValueArray.push([keyTypeArray[i] + ':' + value])
                        }
                    }
                }

                hardware.push('set ' + key + ' to ' + value)
            })
        }

        return (
            <div>
                Click on the hand hex and click on action hex ,double click the
                action hex and select {value.type}{' '}
                {
                    <div>
                        {' '}
                        Set{' '}
                        {Object.entries(value.state).map(([key, value]) => {
                            return (
                                <span>
                                    {' '}
                                    {key} {value}
                                </span>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }

    checkForSimulation = () => {
        // let {bottomPanel} = this.props.logic
        // if(bottomPanel){
        //   return;
        // }
        if (sessionStorage.getItem('PET') == null) {
            this.setState({ checkEndProgram: true })
            return
        }
        localStorage.setItem('recoveryData', JSON.stringify(sessionStorage))
        if (this.state.readyForSimulation === 'repeat') {
            this.props.history.push('/simulate')
            window.location.reload(false)
        } else {
            this.setState({ checkEndProgram: true })
        }
    }
    closecheckEndProgram = () => {
        this.setState({ checkEndProgram: false })
    }
    closeExcitDataLimitPopup = () => {
        this.setState({ excitDataLimitPopup: false })
    }

    getStepsSlideCount = (stepsData) => {
        if (!stepsData) return 0
        const stepCount =
            Number(stepsData.totalSteps || stepsData.steps?.length || 0) || 0
        return stepCount
    }

    // ITS =(e) => {
    //   alert(e)
    // }
    async writePort(data) {
        try {
            const filters = [{ usbVendorId: 0x1a86, usbProductId: 0x7523 }]
            const ports = await navigator.serial.getPorts({ filters })
            console.log('portsss', ports)

            console.log('portsss', ports[0].writable, this.props.webSerial.port)
            // const outputStream = ports[0].writable,
            if (this.props.webSerial.port !== undefined) {
                const writer = this.props.webSerial.port.writable.getWriter()
                // writer = outputStream.getWriter();
                const sata = data
                const data1 = new Uint8Array(sata) // hello// 82, 76, 0, 0, 0, 82, 0, 0, 0, 66, 0, 0, 1, 0, 1,
                console.log('send data:+', data1)

                await writer.write(data1)

                writer.releaseLock()
            }
        } catch (e) {
            console.log(e)
        }
    }

    showUploadSucessError = (message) => {
        this.setState({
            uploadSucessError: {
                isShow: true,
                message: message,
            },
            uploadOpen: false,
        })
        // this.setState({ uploadOpen: false })
        setTimeout(
            () =>
                this.setState({
                    uploadSucessError: {
                        isShow: false,
                        message: '',
                    },
                }),
            2500
        )
    }

    bytesSending = async (data) => {
        // if (
        //     (sessionStorage.getItem('connectedDevice') == 'Ace' &&
        //         sessionStorage.getItem('deviceVersion')?.includes('1.0.0')) ||
        //     sessionStorage.getItem('deviceVersion').includes('2.0.0')
        // ) {

        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')
        let assemblyPageAi = this.props.assembly.assemblyPageAi
        let hexProgram = this.props.logic.program
        let PortConnections = this.props.assembly.PortConnections
        const ispcAiTool1Present = isAi1ShowCondition({
            connectedDevice,
            deviceVersion,
        })
        let aIdata = [],
            aIRestData = []
        //generat the peeCee Ai Data
        if (ispcAiTool1Present && PortConnections?.A?.type == 'pcAiTool') {
            aIdata = generateAidata(hexProgram)
            aIRestData = generateAiresetdata()
        }

        try {
            console.log('data is write', data, this.props.worker)
            if (['Roboki', 'Atr'].includes(connectedDevice)) {
                if (data.length > 1020) {
                    this.setState({ uploadOpen: false })
                    this.setState({ excitDataLimitPopup: true })
                    return
                }
            }

            this.props.worker.postMessage({
                type: 'writeArray',
                value: data,
            })
            const doneObj = { sendDataAsPacket: false, readVal: '' }
            // sessionStorage.setItem('sendData_read', JSON.stringify(doneObj))
            this.sendDataRef.current = doneObj

            let replyOK = ''
            try {
                replyOK = await Promise.race([
                    this.checkOk(),
                    this.timeoutPromise(5000), //
                ])
            } catch (e) {
                console.log('ERROR', e)
                this.showUploadSucessError('Program uploading failed')
            }

            let replayAisOk = ''
            let replayAIROk = ''
            if (replyOK == 'OK') {
                //for peeCee v1.0 send the ai module data

                if (
                    // ispcAiTool1Present &&
                    PortConnections?.A?.type == 'pcAiTool'
                ) {
                    this.props.worker.postMessage({
                        type: 'WriteArrayFormat1310',
                        value: aIdata,
                    })
                    const doneObj = { sendDataAsPacket: false, readVal: '' }
                    this.sendDataRef.current = doneObj
                    // sessionStorage.setItem(
                    //     'sendData_read',
                    //     JSON.stringify(doneObj)
                    // )
                    try {
                        replayAisOk = await Promise.race([
                            this.checkOk(),
                            this.timeoutPromise(5000), //
                        ])
                    } catch (e) {
                        console.log(e)
                        if (ispcAiTool1Present) {
                            this.showUploadSucessError(
                                `Program upload to the AI module failed. Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                    connectedDevice
                                )}`
                            )
                        } else {
                            this.setState({ lowerVersionPcAiToolShow: true })
                        }
                    }
                } else {
                    //for roboki reset bytes send after 600ms other awaise not work for dc motor program
                    // if (['Roboki'].includes(connectedDevice)) {
                    //     await new Promise((reslove) => setTimeout(reslove, 600))
                    // }

                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'REST',
                    })
                    this.showUploadSucessError('Program Successfully Uploaded')
                    // this.setState({
                    //     uploadSucessError: {
                    //         isShow: true,
                    //         message: 'Uploading Successful',
                    //     },
                    // })
                    // this.setState({ uploadOpen: false })
                    // setTimeout(
                    //     () =>
                    //         this.setState({
                    //             uploadSucessError: {
                    //                 isShow: false,
                    //                 message: '',
                    //             },
                    //         }),
                    //     2500
                    // )
                }
            }

            if (PortConnections?.A?.type == 'pcAiTool') {
                if (replayAisOk[3] == 83 && replayAisOk[4] == 1) {
                    this.props.worker.postMessage({
                        type: 'WriteArrayFormat1310',
                        value: aIRestData,
                    })
                    const doneObj = { sendDataAsPacket: false, readVal: '' }
                    // sessionStorage.setItem('sendData_read', JSON.stringify(doneObj))
                    this.sendDataRef.current = doneObj
                    try {
                        replayAIROk = await Promise.race([
                            this.checkOk(),
                            this.timeoutPromise(2000), //
                        ])
                    } catch (e) {
                        console.log('ERROR', e)
                        if (ispcAiTool1Present) {
                            this.showUploadSucessError(
                                `Program upload to the AI module failed. Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                    connectedDevice
                                )}`
                            )
                        } else {
                            this.setState({ lowerVersionPcAiToolShow: true })
                        }
                    }
                } else {
                    // this.setState({ uploadOpen: false })
                    // window.alert('proggam does not upload.')
                    if (ispcAiTool1Present) {
                        this.showUploadSucessError(
                            `Program upload to the AI module failed. Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                connectedDevice
                            )}`
                        )
                    } else {
                        this.setState({ lowerVersionPcAiToolShow: true })
                    }
                }

                if (replayAIROk[3] == 88 && replayAIROk[4] == 1) {
                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'REST',
                    })
                    this.showUploadSucessError('Program Successfully Uploaded')
                    // this.setState({
                    //     uploadSucessError: {
                    //         isShow: true,
                    //         message: 'Uploading Successful',
                    //     },
                    // })
                    // this.setState({ uploadOpen: false })
                    // setTimeout(
                    //     () =>
                    //         this.setState({
                    //             uploadSucessError: {
                    //                 isShow: false,
                    //                 message: '',
                    //             },
                    //         }),
                    //     2500
                    // )
                }
            }
            // console.log('XXXXXXXXXXXXX', replyOK)
        } catch (e) {
            const doneObj = { sendDataAsPacket: true, readVal: '' }
            // sessionStorage.setItem('sendData_read', JSON.stringify(doneObj))
            this.sendDataRef.current = doneObj
            console.log('Error', e)
            // setDisplay('block')
        }
    }
    uploadProgram = async ({ save }) => {
        //for clearing the chunks
        this.props.worker.postMessage({
            type: 'clearChunks',
        })
        sessionStorage.setItem('isPlay', false)
        var params = {
            screen: 'hexa',
            logic: this.props.logic,
            components: this.props.assembly.PortConnections,
            internalaccessories: JSON.parse(sessionStorage.getItem('concept'))
                .internalaccessories,
        }
        if (sessionStorage.getItem('PET') == null) {
            this.setState({ checkEndProgram: true })
            return
        }
        console.log(this.props.logic)
        if (!save) {
            this.setState({ uploadOpen: true })
        }
        if (this.state.checkEndProgram) return
        if (!this.props.webSerial.isConnected) return
        //debugger;
        var upldbtn = document.getElementById('uploadLogicscrn')
        upldbtn.style.pointerEvents = 'none'
        upldbtn.style.cursor = 'none'
        await getBytes({ code: params })
        let bytes = sessionStorage.getItem('convert_Bytes')
        var data = bytes.split(',')
        console.log(data, 'KAMAL SIMULATE')
        //this.myRef.current.upload();

        // await this.writePort(data);
        // this.readForSucess();

        // Sending Bytes and Receiving for 'OK' acknowledgement
        // const writer = this.props.webSerial.port.writable.getWriter();
        // await writer.releaseLock();
        // const reader = await this.props.webSerial.port.readable.getReader();
        // await reader.releaseLock()

        /** if (
            !(
                sessionStorage.getItem('deviceVersion')?.startsWith('1') &&
                ['Ace'].includes(sessionStorage.getItem('connectedDevice'))
            ) &&
            !['Humanoid', 'Roboki', 'Hexapod'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        ) {
            console.log(this.props.webSerial.port.readable.locked, 'gsk prot')
            try {
                await this.props.webSerial.port.readable.cancel()
            } catch (e) {
                console.log(e)
            }
        }
**/

        if (save) {
            return data
        } else {
            await this.bytesSending(data)
            setTimeout(() => {
                upldbtn.style.cursor = 'pointer'
                upldbtn.style.pointerEvents = 'all'
            }, 2500)
        }
    }
    //older firmware upload with ack
    // uploadProgram = () => {
    //   var params = {
    //     screen: "hexa",
    //     logic: this.props.logic,
    //     components: this.props.assembly.PortConnections,
    //     internalaccessories: JSON.parse(sessionStorage.getItem("concept"))
    //       .internalaccessories,
    //   };
    //   this.setState({ uploadOpen: true });
    //   var upldbtn = document.getElementById("uploadLogicscrn");
    //   upldbtn.style.pointerEvents = "none";
    //   upldbtn.style.cursor = "none";
    //   getBytes({ code: params });
    //   let bytes = sessionStorage.getItem("convert_Bytes");
    //   var data = bytes.split(",");
    //   console.log(data, "KAMAL SIMULATE");
    //   //this.myRef.current.upload();
    //   // this.writePort(data);
    //   sendBytes(data, this.props.webSerial.port);
    //   setTimeout(() => {
    //     upldbtn.style.cursor = "pointer";

    //     upldbtn.style.pointerEvents = "all";
    //     this.setState({ uploadOpen: false });
    //   }, 3000);

    //   // console.log("UPLOAD DATA", this.myRef.current.upload()); //it will call anyFun which is available at simulateLogic.js
    // };

    //checks if the current connected device is support to save the program to the board
    getIsSaveToBoard = () => {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')

        // Supported device versions
        let supportedDevice = {
            Humanoid: { major: 3 },
            Hexapod: { major: 3 },
            Klaw: { major: 1, patch: 3 }, // Klaw requires minor version check too
        }

        if (
            !deviceVersion ||
            !connectedDevice ||
            !supportedDevice?.[connectedDevice]
        ) {
            return false
        }

        const [majorStr, minorStr, patchStr] = deviceVersion.split('.')
        const major = parseInt(majorStr, 10)
        const patch = parseInt(patchStr, 10)

        const required = supportedDevice[connectedDevice]

        // Special case for Klaw (requires major + minor check)
        if (connectedDevice === 'Klaw') {
            return (
                major > required.major ||
                (major === required.major && patch >= required.patch)
            )
        }

        // Default check for other devices (major version only)
        return major >= required.major
    }

    setFilePopUp = (value) => {
        this.setState({ filePopup: value })
    }

    //save hex programming to the board bytes format
    programsaveToBoard = async (microPython) => {
        if (microPython) {
            return
        }
        // saveToLocalStorage()
        if (
            this.state.readyForSimulation !== 'repeat' &&
            this.state.readyForSimulation !== 'end'
        ) {
            this.setState({ checkEndProgram: true })
        } else {
            return await this.uploadProgram({ save: true })
        }
    }

    loadLogicSteps = async () => {
        try {
            // Using the same projectId logic as AssemblyTwo
            const apiProjectId =
                sessionStorage.getItem('apiProjectId') || 'talking-dragon'

            // We always want staging data for logicTwoContent
            const isPreviewMode = true
            sessionStorage.setItem('apiProjectId', apiProjectId)

            // Call the API — pass the hex screenId from URL params
            const hexScreenId = this.props.match?.params?.screenId || ''
            const stepsData = await fetchHexSteps(
                apiProjectId,
                isPreviewMode,
                hexScreenId
            )

            // ---> SET THE DEFAULT VALUE HERE <---
            const defaultScreen =
                stepsData?.assemblyScreenId ||
                this.state.assemblyScreens[0] ||
                ''

            console.log('defaultScreen', defaultScreen)

            if (this._isMounted) {
                this.setState({ selectedAssemblyScreen: defaultScreen })
            }

            // Now that state is set, build the connections for this specific screen
            await this.ensureAssemblyConnections(defaultScreen)
            // ------------------------------------

            // v2.0 format: restore tutorial capture state and rebuild the hex board
            if (stepsData?.codeSteps && stepsData.codeSteps.length > 0) {
                const microSlides = flattenToMicroSlides(stepsData)
                const lastSlideIndex = Math.max(0, microSlides.length - 1)
                const lastMicroSlide = microSlides[lastSlideIndex]

                // Rebuild the hex board to the final captured step
                if (lastMicroSlide) {
                    const { logic } = buildStateForMicroSlide(
                        stepsData.codeSteps,
                        lastMicroSlide
                    )

                    const logicForInitialLoad = JSON.parse(
                        JSON.stringify(logic)
                    )
                    // On initial page load, always keep the editor area visible.
                    logicForInitialLoad.bottomPanel = 'border'

                    this.skipHexSyncOnce = true
                    this.props.update(logicForInitialLoad)
                    sessionStorage.removeItem('currentActiveHexBlock')

                    // Sync end-program state
                    const endState = logic.end?.state
                    if (endState === 'repeat' || endState === 'end') {
                        this.setState({ readyForSimulation: endState })
                        sessionStorage.setItem('programEnd', endState)
                    }
                }

                // Restore the tutorial capture state so the admin can resume editing
                this.setState({
                    logicSteps: stepsData,
                    stepsSlideIndex: 0,
                    tutorialCodeSteps: stepsData.codeSteps,
                    tutorialStepCounter: stepsData.codeSteps.length,
                    tutorialMeta: {
                        tutorialId:
                            stepsData.tutorialId ||
                            stepsData.meta?.tutorialId ||
                            '0',
                        title: stepsData.meta?.title || 'Untitled',
                        description:
                            stepsData.meta?.description || 'No description',
                    },
                    tutorialRecording: true,
                    hasSubmittedSteps: true,
                    hexInteractionLocked: true,
                })
            } else {
                // No saved data or v1.0 format — start fresh
                this.setState({
                    logicSteps: stepsData,
                    stepsSlideIndex: 0,
                })
            }
        } catch (error) {
            console.error('Failed to load logic steps', error)
        }
    }

    handleStepsPrev = () => {
        const stepsData = this.state.logicSteps
        if (!stepsData) return

        // Note: AssemblyTwo had logic here to "undo" connections visually.
        // For Logic, unless you have a specific 'removeBlock' function ready,
        // we just handle the slide navigation.

        const nextIndex = Math.max(this.state.stepsSlideIndex - 1, 0)
        this.setState({ stepsSlideIndex: nextIndex })
    }

    handleStepsNext = () => {
        const stepsData = this.state.logicSteps
        if (!stepsData) return

        const totalSlides = this.getStepsSlideCount(stepsData)
        if (!totalSlides) return

        const nextIndex = Math.min(
            this.state.stepsSlideIndex + 1,
            totalSlides + 1
        )
        this.setState({ stepsSlideIndex: nextIndex })
    }

    render = () => {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        console.log('Logic CONDITION PROPS', this.props)
        // const connectedDevice = sessionStorage.getItem('connectedDevice')
        const { program, scale, offset, currentProgramGuide, active } =
            this.props.logic
        const languageName = this.props.device.language
        let microPython
        try {
            microPython = JSON.parse(sessionStorage.getItem('microPython'))
        } catch (e) {
            microPython = false
        }

        const stepsData = this.state.logicSteps
        const activeSlideIndex = this.state.stepsSlideIndex
        const totalSlides = this.getStepsSlideCount(stepsData)
        const isUploadStep = activeSlideIndex === totalSlides

        const stepIndex = activeSlideIndex

        const activeStep = stepsData?.steps?.[stepIndex]
        const isActionSlide = activeSlideIndex % 2 === 1

        // Define Title and Instruction
        let slideTitle = activeStep?.title ?? ''
        let slideInstruction = activeStep ? activeStep.instruction : '' // Assuming API returns 'instruction'
        const microSlides = this.state.microSlides

        if (activeSlideIndex === totalSlides) {
            slideTitle = 'Excellent!'
            slideInstruction =
                'Excellent! You have successfully built the logic.'
        } else if (activeSlideIndex === totalSlides + 1) {
            slideTitle = 'Upload Code'
            slideInstruction = 'Please upload the code to see it in action!'
        } else if (
            stepsData?.codeSteps &&
            microSlides &&
            microSlides.length > 0
        ) {
            // FIX: Added the closing parenthesis and bracket that were missing
            const currentMicroSlide = microSlides[activeSlideIndex]
            if (currentMicroSlide) {
                slideTitle = currentMicroSlide.title
                slideInstruction = currentMicroSlide.instruction
            }
        } else if (stepsData?.steps) {
            // v1.0 legacy format fallback
            slideTitle = activeStep?.title ?? ''
            slideInstruction = activeStep ? activeStep.instruction : ''
        }

        const hexSteps = this.state.tutorialCodeSteps || []

        var tempData
        countLogic = 0
        //description
        if (localStorage.getItem('programMode') == 'learn') {
            this.state.tutorialDesc.map((value, index) => {
                // (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value) : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                // return <div>{index}{value.type}</div>
                if (countLogic == 0) {
                    if (program[index]) {
                        if (program[index].type != 'start') {
                            if (program[index].type == value.type) {
                                // console.log("program check khushboo", value, program[index].state, countLogic, JSON.stringify(program[index].state) == JSON.stringify(value.state))
                                // _.isEqual(program[index].state, value.state);
                                if (
                                    _.isEqual(program[index].state, value.state)
                                ) {
                                    if (value.subprogram !== undefined) {
                                        value.subprogram.map(
                                            (value1, indexSub) => {
                                                if (
                                                    program[index].subprogram[
                                                        indexSub
                                                    ] &&
                                                    value.subprogram[indexSub]
                                                ) {
                                                    if (
                                                        program[index]
                                                            .subprogram[
                                                            indexSub
                                                        ].type ==
                                                        value.subprogram[
                                                            indexSub
                                                        ].type
                                                    ) {
                                                        if (
                                                            _.isEqual(
                                                                program[index]
                                                                    .subprogram[
                                                                    indexSub
                                                                ].state,
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].state
                                                            )
                                                        ) {
                                                            // countLogic++
                                                            // tempData = (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value, "state") : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                                                        } else {
                                                            countLogic++
                                                            tempData =
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].type ==
                                                                    'hardware' ||
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].type ==
                                                                    'variable' ||
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].type == 'wait'
                                                                    ? this.output(
                                                                          value
                                                                              .subprogram[
                                                                              indexSub
                                                                          ],
                                                                          'state'
                                                                      )
                                                                    : value.type ==
                                                                            'sensor' ||
                                                                        value.type ==
                                                                            'variable'
                                                                      ? this.if(
                                                                            value,
                                                                            'state'
                                                                        )
                                                                      : ''
                                                        }
                                                    } else {
                                                        countLogic++
                                                        tempData =
                                                            value.subprogram[
                                                                indexSub
                                                            ].type ==
                                                                'hardware' ||
                                                            value.subprogram[
                                                                indexSub
                                                            ].type ==
                                                                'variable' ||
                                                            value.subprogram[
                                                                indexSub
                                                            ].type == 'wait'
                                                                ? this.output(
                                                                      value
                                                                          .subprogram[
                                                                          indexSub
                                                                      ]
                                                                  )
                                                                : value.type ==
                                                                        'sensor' ||
                                                                    value.type ==
                                                                        'variable'
                                                                  ? this.if(
                                                                        value,
                                                                        'subprogram'
                                                                    )
                                                                  : ''
                                                    }
                                                } else {
                                                    countLogic++
                                                    tempData =
                                                        value.subprogram[
                                                            indexSub
                                                        ].type == 'hardware' ||
                                                        value.subprogram[
                                                            indexSub
                                                        ].type == 'variable' ||
                                                        value.subprogram[
                                                            indexSub
                                                        ].type == 'wait'
                                                            ? this.output(
                                                                  value
                                                                      .subprogram[
                                                                      indexSub
                                                                  ]
                                                              )
                                                            : value.type ==
                                                                    'sensor' ||
                                                                value.type ==
                                                                    'variable'
                                                              ? this.if(
                                                                    value,
                                                                    'subprogram'
                                                                )
                                                              : ''
                                                }
                                            }
                                        )
                                    }
                                    // countLogic++
                                    // tempData = (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value, "state") : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                                } else {
                                    countLogic++
                                    tempData =
                                        value.type == 'hardware' ||
                                        value.type == 'variable' ||
                                        value.type == 'wait'
                                            ? this.output(value, 'state')
                                            : value.type == 'sensor' ||
                                                value.type == 'variable'
                                              ? this.if(value, 'state')
                                              : ''
                                }
                            } else {
                                countLogic++
                                tempData =
                                    value.type == 'hardware' ||
                                    value.type == 'variable' ||
                                    value.type == 'wait'
                                        ? this.output(value)
                                        : value.type == 'sensor' ||
                                            value.type == 'variable'
                                          ? this.if(value)
                                          : ''
                            }
                        }
                    } else {
                        countLogic++

                        tempData =
                            value.type == 'hardware' ||
                            value.type == 'variable' ||
                            value.type == 'wait'
                                ? this.output(value)
                                : value.type == 'sensor' ||
                                    value.type == 'variable'
                                  ? this.if(value)
                                  : ''
                    }
                }
                // tempData = <div>hye</div>
            })
        }
        // As according to app approx 11.5 hexagons in a row in the display

        defaultScale = SizesHelper.width / (18.5 * Sizes.xdiff)
        var { bottomPanel } = this.props.logic

        const { height, width } = this.props.assembly

        var value = {}
        var current = ''
        var App = this.props.app
        var LogicFlowButtons
        var logicEditorScreenType = this.state.currentLogicScreen
        var assemblyData = this.props.assembly // Fallback to Redux if session storage fails

        try {
            const sessionData = JSON.parse(
                sessionStorage.getItem('assemblyTwo')
            )
            // Ensure session data exists and has the required structure
            if (
                sessionData &&
                sessionData.workspace &&
                sessionData.PortConnections
            ) {
                assemblyData = sessionData
            }
        } catch (e) {
            console.log('Error reading assemblyTwo from Session Storage:', e)
        }

        var { components } = assemblyData.workspace
        var { PortConnections } = assemblyData

        // Object.keys(PortConnections).map(port => PortConnections[port] = null);
        Object.keys(components).map((type) => {
            components[type].map((component, index) => {
                if (type == 'dc_motor' && component.connectedTo == 'A2') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['A1'] = { type, index }
                }
                if (type == 'dc_motor' && component.connectedTo == 'A3') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['A4'] = { type, index }
                }
                if (type == 'dc_motor' && component.connectedTo == 'F1') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['F2'] = { type, index }
                }
                if (type == 'dc_motor' && component.connectedTo == 'G1') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['G2'] = { type, index }
                } else if (connectedDevice !== 'Atr') {
                    PortConnections[component.connectedTo] = { type, index }
                }
            })
        })

        if (active) {
            if (active[0] !== -1)
                current = drawing.board[active[0]][active[1]].type
        }

        //console.log("curdraw", row);
        for (var row in drawing.board) {
            for (var i in drawing.board[row]) {
                //console.log("curdraw", drawing.board[row][i]);
                var block = drawing.board[row][i].type
                if (block == 'active_hand') {
                    i++
                    block = drawing.board[row][i].type
                    console.log('active end', block)
                    if (block.startsWith('end')) {
                        // console.log("active final", drawing.board[row][i]);
                        //drawing.board[row][i] = { type: "blank" };
                    }
                }
            }
        }
        // console.log("curdraw", drawing, active);
        if (
            current === 'blank' ||
            current === 'active_hand' ||
            current === '' ||
            current === 'hand' ||
            current === 'highlighted_hand' ||
            current == 'action'
        )
            bottomPanel = 'none'

        if (drawing && drawing.activeRef.state) {
            value = drawing.activeRef.state
        }
        if (!drawing.activeRef.state) {
            drawing.activeRef.state = {}
        }
        if (this.state.detected == true) {
            var imageURL = 'images/Learn/ble_connection.png'
        } else {
            imageURL = 'images/Learn/ble_disconnection.png'
        }
        newId = newArr.push(Math.floor(Math.random() * 1000000000000))

        console.log('DRAWING REF', drawing.activeRef)
        const { slideDirection } = this.state

        return (
            <>
                <SavePopUpTwo
                    showPopUp={this.state.filePopup}
                    setFilePopUp={this.setFilePopUp}
                    isNotCreateAction={true}
                    isShowNewUI={false}
                    audioFile={''}
                    setAudioFile={() => {}}
                    projectName={''}
                    programsaveToBoard={async () =>
                        await this.programsaveToBoard(microPython)
                    }
                />

                <DialogModal
                    show={this.state.excitDataLimitPopup}
                    text="Your current program exceed the size limit."
                    showCloseBtn={true}
                    handleDialogModalClose={this.closeExcitDataLimitPopup}
                />
                <DialogModal
                    show={this.state.checkEndProgram}
                    text="Please end the program with Loop or Stop."
                    showCloseBtn={true}
                    handleDialogModalClose={this.closecheckEndProgram}
                />
                <DialogModal
                    show={this.state.uploadOpen}
                    text={
                        this.props.webSerial.isConnected
                            ? 'Uploading Program'
                            : 'Connect your device to upload program.'
                    }
                    showCloseBtn={true}
                    handleDialogModalClose={this.closeUpload}
                />
                <DialogModal
                    show={this.state.uploadSucessError.isShow}
                    text={this.state.uploadSucessError.message}
                    showCloseBtn={true}
                    handleDialogModalClose={this.closeUploadSucess}
                />
                <DialogModal
                    show={this.state.lowerVersionPcAiToolShow}
                    text={
                        <p>
                            {`AI-1 accessory is not compatible with the current firmware version. Please update the ${getDeviceName(
                                connectedDevice
                            )} using the firmware updation tool `}
                            <a
                                href="https://firmware.plode.org"
                                target="_blank"
                            >
                                Here.
                            </a>
                        </p>
                    }
                    showCloseBtn={true}
                    handleDialogModalClose={() =>
                        this.setState({ lowerVersionPcAiToolShow: false })
                    }
                />
                <DialogModal
                    show={this.state.clearProgramModal}
                    text="Are you sure you want to clear this program"
                    optionsToSelect={[
                        { text: 'YES', do: this.clearProgram },
                        { text: 'NO', do: this.clearProgramfalse },
                    ]}
                />
                <DialogModal
                    show={this.state.modalIsOpen}
                    text="Device not connected!"
                    showCloseBtn={true}
                    handleDialogModalClose={this.close}
                    optionsToSelect={[
                        {
                            text: 'Reconnect',
                            do: () => {
                                this.props.history.push('/deviceSelection')
                            },
                        },
                    ]}
                />

                {this.state.showCaptureMessage && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 99999,
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '12px 20px',
                            pointerEvents: 'none',
                        }}
                    >
                        <div
                            style={{
                                background: 'rgba(0, 0, 0, 0.55)',
                                color: '#fff',
                                padding: '10px 24px',
                                borderRadius: '8px',
                                fontSize: '15px',
                                fontWeight: 600,
                                textAlign: 'center',
                                animation:
                                    'captureBlink 2s ease-in-out infinite',
                            }}
                        >
                            Screen capturing started! Click the 'Save to
                            Staging' once you're done.
                        </div>
                    </div>
                )}
                <style>{`
                    @keyframes captureBlink {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.6; }
                    }
                `}</style>
                <div
                    style={{
                        // backgroundColor: "rgb(166, 209, 225)",
                        background: '#FCFCFC',
                        height: '100%',
                        width: '100vw',
                        overflow: 'hidden',
                        userSelect: 'none',
                    }}
                >
                    {/* HAX BLOCKS  */}

                    <div
                        className={`${
                            slideDirection === 'true'
                                ? 'slide-right'
                                : 'slide-left'
                        }`}
                        style={{ height: '80%' }}
                    >
                        {' '}
                        <div className="draw" style={{ height: '80%' }}>
                            {/* <Link to="/assembly">
            <div className="back_btn_logic">BACK</div>
          </Link> */}

                            {/* <div className="XXX">HELLO BUDDY</div> */}
                            <div onWheel={this.wheel}>
                                <Hammer
                                    onPan={this.pan}
                                    onPanStart={this.panStart}
                                    onPanEnd={this.panEnd}
                                    onPinchIn={this.pinchIn}
                                    onPinchOut={this.pinchOut}
                                    options={{
                                        recognizers: {
                                            pinch: { enable: true },
                                        },
                                    }}
                                >
                                    <div
                                        className="draw"
                                        style={{
                                            height: '1000px',
                                        }}
                                    >
                                        {/* <img
                  style={{
                    position: "absolute",
                    top: "4.8%",
                    rotate: "-90deg",
                    left: "36.5%",
                  }}
                  src={renderPrgImage("StartArrow")}
                ></img> */}
                                        <svg
                                            height="100%"
                                            width="100%"
                                            style={{
                                                backgroundColor: '#FCFCFC',
                                            }}
                                            className="noselect"
                                        >
                                            <g
                                                transform={
                                                    'scale(' +
                                                    defaultScale +
                                                    ')'
                                                }
                                            >
                                                <g
                                                    transform={
                                                        'scale(' + scale + ')'
                                                    }
                                                    id="logicScaleTransformer"
                                                >
                                                    <g
                                                        transform={
                                                            'translate(' +
                                                            offset.left +
                                                            ',' +
                                                            offset.top +
                                                            ')'
                                                        }
                                                        id="logicOffsetTransformer"
                                                    >
                                                        <HexBoard
                                                            hexType={
                                                                this.state
                                                                    .hexType
                                                            }
                                                            drawing={drawing}
                                                            onClick={this.click}
                                                            onDoubleClick={
                                                                this
                                                                    .toggleBottomPanel
                                                            }
                                                            // onClick={this.ITS}
                                                            id={IDIS}
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        {/* <div style={{ height: "10%", width: "65%", border: "2px solid #bed5fa", backgroundColor: "white", borderRadius: "20px", top: "80vh", left: "10%", position: 'inherit' }}>
                <h3 style={{ marginLeft: "20px", marginTop: "2px" }}>
                  {Object.entries(this.state.tutorialDesc).map(([key, value]) => {
                    console.log("logic Connections 2", key, value)
                    return < div> {parseInt(key) + 1}. {value}</div>
                  })}
                </h3>
              </div> */}

                                        {localStorage.getItem('programMode') ==
                                            'learn' && tempData ? (
                                            <div
                                                style={{
                                                    height: 'auto',
                                                    width: '65vw',
                                                    border: '2px solid #bed5fa',
                                                    backgroundColor: 'white',
                                                    borderRadius: '20px',
                                                    bottom: '3%',
                                                    left: '17%',
                                                    position: 'fixed',
                                                }}
                                            >
                                                <h3
                                                    style={{
                                                        marginLeft: '20px',
                                                        marginTop: '2px',
                                                    }}
                                                >
                                                    {/* {this.state.tutorialDesc[0].type} */}

                                                    {/* {Object.entries(this.state.tutorialDesc).map(([key, value]) => {
                    console.log("logic Connections 2", key, value)
                    return < div> {key}. {value}</div>
                  })} */}

                                                    {/* {this.state.tutorialDesc.map((value, index) => {
                    console.log("program check", program[index].type)
                    return (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value) : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                    // return <div>{index}{value.type}</div>
                  })} */}
                                                    {tempData}
                                                </h3>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </Hammer>
                            </div>

                            {/* OPEN THE PANEL THIE ACTIONS When you dubble click it will open  */}

                            <BottomPanel
                                componentProps={
                                    this.props.concept.componentProps
                                }
                                PortConnections={PortConnections}
                                value={value}
                                show={bottomPanel}
                                toggle={this.toggleBottomPanel}
                                current={current}
                                state={drawing.activeRef.state}
                                nodeId={drawing.activeRef.nodeId}
                                onChange={this.bottomPanelChange}
                                startState={program[0].state}
                                hexTypeCheck={this.hexTypeCheck}
                                bottomPanelDeleteKey={this.bottomPanelDelete}
                                onCaptureReadAction={this.captureReadAction}
                            />
                        </div>
                    </div>

                    {/* bottom */}
                    <div
                        style={{
                            height: '10%',
                            position: 'relative',
                            zIndex: '10',
                        }}
                    >
                        {/* <LogicStepsSlideshow
                            slideIndex={activeSlideIndex}
                            totalSlides={totalSlides}
                            title={slideTitle}
                            instruction={slideInstruction}
                            onPrev={this.handleStepsPrev}
                            onNext={this.handleStepsNext}
                        /> */}
                        <div className="hex-steps-dialog">
                            {/* Subprogram heading row */}
                            <div
                                style={{
                                    marginBottom: '12px',
                                    padding: '10px 14px',
                                    background:
                                        'linear-gradient(90deg, #eef4ff 0%, #f8fbff 100%)',
                                    border: '1px solid #dbe7ff',
                                    borderRadius: '10px',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '0.7rem',
                                            fontWeight: 700,
                                            color: '#5b6b8c',
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        Current Project
                                    </div>

                                    <h1
                                        style={{
                                            margin: 0,
                                            fontSize: '1.25rem',
                                            fontWeight: 800,
                                            color: '#1f3b77',
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        {this.subprogramTitle}
                                    </h1>
                                </div>
                            </div>

                            {/* ── Assembly screen picker ── */}
                            {this.state.assemblyScreens.length > 0 && (
                                <div
                                    style={{
                                        marginBottom: '12px',
                                        padding: '8px 14px',
                                        background:
                                            'linear-gradient(90deg, #fff4e6 0%, #fffbf5 100%)',
                                        border: '1px solid #ffe0b2',
                                        borderRadius: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                    }}
                                >
                                    <label
                                        style={{
                                            fontSize: '0.7rem',
                                            fontWeight: 700,
                                            color: '#8c6b3a',
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        Electronic Screen ID
                                    </label>
                                    <select
                                        style={{
                                            flex: 1,
                                            padding: '4px 8px',
                                            borderRadius: '6px',
                                            border: '1px solid #e0c89a',
                                            fontSize: '0.85rem',
                                            fontWeight: 600,
                                            color: '#5b4a2a',
                                            background: '#fff',
                                        }}
                                        value={
                                            this.state.selectedAssemblyScreen
                                        }
                                        onChange={(e) =>
                                            this.handleAssemblyScreenChange(
                                                e.target.value
                                            )
                                        }
                                    >
                                        {this.state.assemblyScreens.map(
                                            (screenId) => (
                                                <option
                                                    key={screenId}
                                                    value={screenId}
                                                >
                                                    {screenId}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            )}

                            {/* ── Header row: step count + step selector ── */}
                            <div className="hex-editor-header">
                                <span className="hex-steps-step">
                                    Steps: {this.state.tutorialCodeSteps.length}
                                </span>
                                <select
                                    className="hex-editor-select"
                                    value={this.state.selectedTutorialStepIndex}
                                    onChange={(event) =>
                                        this.setSelectedTutorialStepIndex(
                                            Number(event.target.value)
                                        )
                                    }
                                >
                                    {hexSteps.map((step, idx) => (
                                        <option key={idx} value={idx}>
                                            Step {step.stepId || idx + 1}
                                            {step.action === 'INSERT_BLOCK'
                                                ? ' (Insert)'
                                                : step.action === 'DELETE_BLOCK'
                                                  ? ' (Delete)'
                                                  : ''}
                                        </option>
                                    ))}
                                </select>
                                <input
                                    className="hex-steps-input"
                                    type="text"
                                    placeholder="Title"
                                    value={this.state.tutorialMeta.title}
                                    onChange={(event) =>
                                        this.handleHexStepMetaChange(
                                            'title',
                                            event.target.value
                                        )
                                    }
                                />
                            </div>

                            {/* ── Instruction fields grid ── */}
                            <div className="hex-editor-fields">
                                <div className="hex-editor-field">
                                    <label className="hex-editor-label">
                                        Before clicking the block
                                    </label>
                                    <input
                                        className="hex-steps-input"
                                        type="text"
                                        placeholder='e.g. "Click the Select block"'
                                        value={
                                            (
                                                hexSteps[
                                                    this.state
                                                        .selectedTutorialStepIndex
                                                ] || {}
                                            ).preMessage || ''
                                        }
                                        onChange={(event) =>
                                            this.updateSelectedStepField(
                                                'preMessage',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="hex-editor-field">
                                    <label className="hex-editor-label">
                                        After clicking the block
                                    </label>
                                    <input
                                        className="hex-steps-input"
                                        type="text"
                                        placeholder='e.g. "Choose the Action block"'
                                        value={
                                            (
                                                hexSteps[
                                                    this.state
                                                        .selectedTutorialStepIndex
                                                ] || {}
                                            ).selectMessage || ''
                                        }
                                        onChange={(event) =>
                                            this.updateSelectedStepField(
                                                'selectMessage',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="hex-editor-field">
                                    <label className="hex-editor-label">
                                        Instruction
                                    </label>
                                    <input
                                        className="hex-steps-input"
                                        type="text"
                                        placeholder='e.g. "Place the Action block"'
                                        value={
                                            (
                                                hexSteps[
                                                    this.state
                                                        .selectedTutorialStepIndex
                                                ] || {}
                                            ).message || ''
                                        }
                                        onChange={(event) =>
                                            this.updateSelectedStepMessage(
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>

                            {/* ── SubStep instructions ── */}
                            {hexSteps[this.state.selectedTutorialStepIndex]
                                ?.subSteps?.length > 0 && (
                                <div className="hex-editor-substeps">
                                    <div className="hex-editor-substep-header">
                                        <label className="hex-editor-label">
                                            Substep Instructions
                                        </label>
                                        <select
                                            className="hex-editor-select"
                                            value={
                                                this.state
                                                    .selectedTutorialSubStepIndex
                                            }
                                            onChange={(event) =>
                                                this.setSelectedTutorialSubStepIndex(
                                                    Number(event.target.value)
                                                )
                                            }
                                        >
                                            {(
                                                hexSteps[
                                                    this.state
                                                        .selectedTutorialStepIndex
                                                ]?.subSteps || []
                                            ).map((sub, idx) => (
                                                <option key={idx} value={idx}>
                                                    Substep{' '}
                                                    {sub.subStepId ||
                                                        `${
                                                            hexSteps[
                                                                this.state
                                                                    .selectedTutorialStepIndex
                                                            ]?.stepId ||
                                                            this.state
                                                                .selectedTutorialStepIndex +
                                                                1
                                                        }-${idx + 1}`}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <input
                                        className="hex-steps-input"
                                        type="text"
                                        placeholder="Substep instruction"
                                        value={
                                            (hexSteps[
                                                this.state
                                                    .selectedTutorialStepIndex
                                            ]?.subSteps || [])[
                                                this.state
                                                    .selectedTutorialSubStepIndex
                                            ]?.message || ''
                                        }
                                        onChange={(event) =>
                                            this.updateSelectedSubStepMessage(
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                            )}

                            {/* ── Action buttons ── */}
                            <div className="hex-editor-actions">
                                <button
                                    type="button"
                                    className="hex-steps-submit"
                                    onClick={this.handleHexStepsSubmit}
                                >
                                    <FaRegSave
                                        style={{
                                            fontSize: '22px',
                                            marginRight: '12px',
                                        }}
                                    />
                                    Save
                                </button>
                                <button
                                    onClick={this.handleGenerateVoiceover}
                                    disabled={this.state.isGeneratingTTS}
                                    className="hex-steps-voiceover"
                                >
                                    {this.state.isGeneratingTTS ? (
                                        'Generating...'
                                    ) : (
                                        <>
                                            <AiOutlineAudio
                                                style={{
                                                    fontSize: '22px',
                                                    marginRight: '12px',
                                                }}
                                            />{' '}
                                            Generate Voiceover
                                        </>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="hex-steps-clear"
                                    onClick={this.handleHexStepsClear}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="hex-steps-play"
                            onClick={this.handleHexStepsPlay}
                        >
                            {this.state.isReplaying
                                ? 'Playing...'
                                : 'Preview Tutorial'}
                        </button>
                        <input
                            ref={this.replayFileInputRef}
                            type="file"
                            accept="application/json,.json"
                            style={{ display: 'none' }}
                            onChange={this.handleHexStepsFileSelect}
                        />
                        {this.state.replayMessage && (
                            <div className="hex-steps-replay-message">
                                {this.state.replayMessage}
                            </div>
                        )}
                    </div>
                    {/* <div
                        className="SelectScreenBottom"
                        style={{
                            zIndex: '1000',
                            bottom: '11%',
                        }}
                    >
                        <div className="bottom-child">
                            <Link to="/assembly">
                                <img
                                    className="iconBtnSize imgBackBtn"
                                    src={renderPrgImage('backBtn')}
                                    style={{ top: '13.7vh' }}
                                    onClick={async () => {
                                        saveToLocalStorage()
                                    }}
                                />
                            </Link>
                            {sessionStorage.getItem('connectedDevice') ===
                                'Ace' &&
                            sessionStorage.getItem('deviceVersion') !== '1.0.03' ? (
                                <img
                                    className="iconBtnSize imgNextBtn"
                                    src={renderPrgImage('nextBtn')}
                                    style={{ top: '13.7vh' }}
                                    onClick={this.checkForSimulation}
                                />
                            ) : null}
                        </div>
                    </div> */}
                    {sessionStorage.getItem('connectedDevice') === 'Ace' &&
                    !sessionStorage.getItem('deviceVersion')?.startsWith('1') &&
                    !['Roboki', 'Toki', 'Poki', 'Atr', 'Moki'].includes(
                        sessionStorage.getItem('connectedDevice')
                    ) ? (
                        <img
                            onClick={() => {
                                if (microPython) {
                                    return
                                }
                                saveToLocalStorage()
                                if (
                                    this.state.readyForSimulation !==
                                        'repeat' &&
                                    this.state.readyForSimulation !== 'end'
                                ) {
                                    this.setState({ checkEndProgram: true })
                                } else {
                                    this.uploadProgram({ save: false })
                                }
                            }}
                            className="nextButton" //search for ".nextButton" in project directory to edit style
                            id="uploadLogicscrn"
                            src={renderPrgImage('uploadBtn')}
                            style={{
                                visibility: 'visible',
                                top: '78vh',
                                opacity: microPython ? '0.5' : '1',
                            }}
                        ></img>
                    ) : (
                        <img
                            onClick={() => {
                                if (microPython) {
                                    return
                                }
                                saveToLocalStorage()
                                if (
                                    this.state.readyForSimulation !==
                                        'repeat' &&
                                    this.state.readyForSimulation !== 'end'
                                ) {
                                    this.setState({ checkEndProgram: true })
                                } else {
                                    this.uploadProgram({ save: false })
                                }
                            }}
                            className="nextButton" //search for ".nextButton" in project directory to edit style
                            id="uploadLogicscrn"
                            src={renderPrgImage('uploadBtn')}
                            style={{
                                visibility: 'visible',
                                top: '91%',
                                width: '60px',
                                height: '60px',
                                cursor: microPython ? 'default' : 'pointer',
                                opacity: microPython ? '0.5' : '1',
                                display: 'none',
                            }}
                        ></img>
                    )}
                </div>

                {this.state.isHelp && (
                    <div className="Ss_slide" style={{ left: '50%' }}>
                        <LogicPrgm />
                        <img
                            className="helpClo"
                            src={renderPrgImage('closBtn')}
                            onClick={this.helpBtn}
                        ></img>
                    </div>
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ...state,
        logic: state.logicTwoContent,
        assembly: state.assemblyTwo,
        hexState: state.hexState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        update: (data) => {
            dispatch({ type: 'LOGIC_SELECTION_TWO_CONTENT', payload: data })
        },
        PortConnections: (data) => {
            dispatch({ type: 'PORT_Connection', payload: data })
        },
        updateAssemblyTwoWorkspace: (data) => {
            dispatch({ type: 'ASSEMBLY_TWO_SELECTION', payload: data })
        },
        updateAssemblyTwoPortConnections: (data) => {
            dispatch({ type: 'PORT_CONNECTION_TWO', payload: data })
        },
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },
        setDisableAfterSettingByt: (data) => {
            dispatch({ type: 'DISABLE_AFTER_SETTING_BYTE', payload: data })
        },
        initHexState: (data) => {
            dispatch(initHexState(data))
        },
        syncHexState: (data) => {
            dispatch(syncHexState(data))
        },
        updateHexStepMeta: (data) => {
            dispatch(updateHexStepMeta(data))
        },
        clearHexSteps: (data) => {
            dispatch(clearHexSteps(data))
        },
        setHexActiveStep: (data) => {
            dispatch(setHexActiveStep(data))
        },
        updateConceptComponentProps: (data) => {
            dispatch({ type: 'COMPONENT_PROPS', payload: data })
        },
        updateConceptInternalAccessories: (data) => {
            dispatch({ type: 'INTERNAL_ACCESSORIES', payload: data })
        },
        updateConceptCounter: (data) => {
            dispatch({ type: 'COMPONENT_SELECTION', payload: data })
        },
    }
}
// Logic = DragDropContext(TouchBackend({ enableMouseEvents: true }))(Logic);
LogicTwoContent = withRouter(DragDropContext(HTML5Backend)(LogicTwoContent))
LogicTwoContent = connect(mapStateToProps, mapDispatchToProps)(LogicTwoContent)
export default LogicTwoContent
